const LookupTable: Map<string, string> = new Map<string, string>
([
    ['\u{1F600}', 'smileys:grinning'],
    ['\u{1F603}', 'smileys:smiley'],
    ['\u{1F604}', 'smileys:smile'],
    ['\u{1F601}', 'smileys:grin'],
    ['\u{1F606}', 'smileys:laughing'],
    ['\u{1F605}', 'smileys:sweat_smile'],
    ['\u{1F923}', 'smileys:rofl'],
    ['\u{1F602}', 'smileys:joy'],
    ['\u{1F642}', 'smileys:slightly_smiling_face'],
    ['\u{1F643}', 'smileys:upside_down_face'],
    ['\u{1FAE0}', 'smileys:melting_face'],
    ['\u{1F609}', 'smileys:wink'],
    ['\u{1F60A}', 'smileys:blush'],
    ['\u{1F607}', 'smileys:innocent'],
    ['\u{1F970}', 'smileys:smiling_face_with_three_hearts'],
    ['\u{1F60D}', 'smileys:heart_eyes'],
    ['\u{1F929}', 'smileys:star_struck'],
    ['\u{1F618}', 'smileys:kissing_heart'],
    ['\u{1F617}', 'smileys:kissing'],
    ['\u{263A}\u{FE0F}', 'smileys:smiling_face'],
    ['\u{1F61A}', 'smileys:kissing_closed_eyes'],
    ['\u{1F619}', 'smileys:kissing_smiling_eyes'],
    ['\u{1F972}', 'smileys:smiling_face_with_tear'],
    ['\u{1F60B}', 'smileys:yum'],
    ['\u{1F61B}', 'smileys:stuck_out_tongue'],
    ['\u{1F61C}', 'smileys:stuck_out_tongue_winking_eye'],
    ['\u{1F92A}', 'smileys:zany_face'],
    ['\u{1F61D}', 'smileys:stuck_out_tongue_closed_eyes'],
    ['\u{1F911}', 'smileys:money_mouth_face'],
    ['\u{1F917}', 'smileys:hugs'],
    ['\u{1F92D}', 'smileys:hand_over_mouth'],
    ['\u{1FAE2}', 'smileys:face_with_open_eyes_and_hand_over_mouth'],
    ['\u{1FAE3}', 'smileys:face_with_peeking_eye'],
    ['\u{1F92B}', 'smileys:shushing_face'],
    ['\u{1F914}', 'smileys:thinking'],
    ['\u{1FAE1}', 'smileys:saluting_face'],
    ['\u{1F910}', 'smileys:zipper_mouth_face'],
    ['\u{1F928}', 'smileys:raised_eyebrow'],
    ['\u{1F610}', 'smileys:neutral_face'],
    ['\u{1F611}', 'smileys:expressionless'],
    ['\u{1F636}', 'smileys:no_mouth'],
    ['\u{1FAE5}', 'smileys:dotted_line_face'],
    ['\u{1F60F}', 'smileys:smirk'],
    ['\u{1F612}', 'smileys:unamused'],
    ['\u{1F644}', 'smileys:rolling_eyes'],
    ['\u{1F62C}', 'smileys:grimacing'],
    ['\u{1F925}', 'smileys:lying_face'],
    ['\u{1FADA}', 'smileys:shaking_face'],
    ['\u{1FAE8}', 'smileys:shaking_face'],
    ['\u{1F60C}', 'smileys:relieved'],
    ['\u{1F614}', 'smileys:pensive'],
    ['\u{1F62A}', 'smileys:sleepy'],
    ['\u{1F924}', 'smileys:drooling_face'],
    ['\u{1F634}', 'smileys:sleeping'],
    ['\u{1F637}', 'smileys:mask'],
    ['\u{1F912}', 'smileys:face_with_thermometer'],
    ['\u{1F915}', 'smileys:face_with_head_bandage'],
    ['\u{1F922}', 'smileys:nauseated_face'],
    ['\u{1F92E}', 'smileys:vomiting_face'],
    ['\u{1F927}', 'smileys:sneezing_face'],
    ['\u{1F975}', 'smileys:hot_face'],
    ['\u{1F976}', 'smileys:cold_face'],
    ['\u{1F974}', 'smileys:woozy_face'],
    ['\u{1F635}\u{200D}\u{1F4AB}', 'smileys:face_with_spiral_eyes'],
    ['\u{1F635}', 'smileys:dizzy_face'],
    ['\u{1F92F}', 'smileys:exploding_head'],
    ['\u{1F920}', 'smileys:cowboy_hat_face'],
    ['\u{1F973}', 'smileys:partying_face'],
    ['\u{1F978}', 'smileys:disguised_face'],
    ['\u{1F60E}', 'smileys:sunglasses'],
    ['\u{1F913}', 'smileys:nerd_face'],
    ['\u{1F9D0}', 'smileys:monocle_face'],
    ['\u{1F615}', 'smileys:confused'],
    ['\u{1F61F}', 'smileys:worried'],
    ['\u{2639}\u{FE0F}', 'smileys:frowning_face'],
    ['\u{1F641}', 'smileys:slightly_frowning_face'],
    ['\u{1F62E}\u{200D}\u{1F4A5}', 'smileys:face_exhaling'],
    ['\u{1F62E}\u{200D}\u{1F4A8}', 'smileys:face_exhaling'],
    ['\u{1F626}', 'smileys:frowning'],
    ['\u{1F627}', 'smileys:anguished'],
    ['\u{1F628}', 'smileys:fearful'],
    ['\u{1F630}', 'smileys:cold_sweat'],
    ['\u{1F625}', 'smileys:sad_relieved'],
    ['\u{1F622}', 'smileys:cry'],
    ['\u{1F62D}', 'smileys:sob'],
    ['\u{1F97A}', 'smileys:pleading'],
    ['\u{1F979}', 'smileys:holding_back_tears'],
    ['\u{1FAEA}', 'smileys:distorted_face'],
    ['\u{1F631}', 'smileys:scream'],
    ['\u{1F633}', 'smileys:flushed'],
    ['\u{1F621}', 'smileys:rage'],
    ['\u{1F620}', 'smileys:angry'],
    ['\u{1F92C}', 'smileys:cursing_face'],
    ['\u{1F624}', 'smileys:triumph'],
    ['\u{1F608}', 'smileys:smiling_imp'],
    ['\u{1F47F}', 'smileys:imp'],
    ['\u{1F480}', 'smileys:skull'],
    ['\u{2620}\u{FE0F}', 'smileys:skull_and_crossbones'],
    ['\u{1F4A9}', 'smileys:poop'],
    ['\u{1F921}', 'smileys:clown_face'],
    ['\u{1F47B}', 'smileys:ghost'],
    ['\u{1F47D}', 'smileys:alien'],
    ['\u{1F47E}', 'smileys:space_invader'],
    ['\u{1F916}', 'smileys:robot'],
    ['\u{1F479}', 'smileys:ogre'],
    ['\u{1F47A}', 'smileys:goblin'],
    ['\u{1F63A}', 'smileys:cat/grinning_cat'],
    ['\u{1F638}', 'smileys:cat/grinning_cat_with_smiling_eyes'],
    ['\u{1F639}', 'smileys:cat/cat_with_tears_of_joy'],
    ['\u{1F63B}', 'smileys:cat/heart_eyes_cat'],
    ['\u{1F63C}', 'smileys:cat/cat_with_wry_smile'],
    ['\u{1F63D}', 'smileys:cat/kissing_cat'],
    ['\u{1F640}', 'smileys:cat/weary_cat'],
    ['\u{1F63F}', 'smileys:cat/crying_cat'],
    ['\u{1F63E}', 'smileys:cat/pouting_cat'],
    ['\u{1F648}', 'smileys:monkey/see_no_evil'],
    ['\u{1F649}', 'smileys:monkey/hear_no_evil'],
    ['\u{1F64A}', 'smileys:monkey/speak_no_evil'],
    ["\u{2764}", "smileys:heart/red_heart"],
    ['\u{1F9E1}', 'smileys:heart/orange_heart'],
    ['\u{1F49B}', 'smileys:heart/yellow_heart'],
    ['\u{1F49A}', 'smileys:heart/green_heart'],
    ['\u{1F499}', 'smileys:heart/blue_heart'],
    ['\u{1F49C}', 'smileys:heart/purple_heart'],
    ['\u{1F5A4}', 'smileys:heart/black_heart'],
    ['\u{1F90D}', 'smileys:heart/white_heart'],
    ['\u{1F90E}', 'smileys:heart/brown_heart'],
    ['\u{1F494}', 'smileys:heart/broken_heart'],
    ['\u{2764}\u{FE0F}\u{200D}\u{1F525}', 'smileys:heart/heart_on_fire'],
    ['\u{2764}\u{FE0F}\u{200D}\u{1FA79}', 'smileys:heart/mending_heart'],
    ['\u{1F495}', 'smileys:heart/two_hearts'],
    ['\u{1F496}', 'smileys:heart/sparkling_heart'],
    ['\u{1F497}', 'smileys:heart/growing_heart'],
    ['\u{1F493}', 'smileys:heart/beating_heart'],
    ['\u{1F49E}', 'smileys:heart/revolving_hearts'],
    ['\u{1F498}', 'smileys:heart/cupid_heart'],
    ['\u{1F49D}', 'smileys:heart/heart_with_ribbon'],
    ['\u{1F49F}', 'smileys:heart/heart_decoration'],
    ['\u{2728}', 'smileys:sparkles'],
    ['\u{1F4A5}', 'smileys:collision'],
    ['\u{1F4AB}', 'smileys:dizzy'],
    ['\u{1F4A6}', 'smileys:sweat_drops'],
    ['\u{1F4A8}', 'smileys:dash'],
    ['\u{1F4A3}', 'smileys:bomb'],
    ['\u{1F4AC}', 'smileys:speech_balloon'],
    ['\u{1F4AD}', 'smileys:thought_balloon'],
    ['\u{1F4AF}', 'smileys:hundred'],
    ['\u{1F4A1}', 'smileys:light_bulb'],
    ['\u{1F4A4}', 'smileys:zzz'],
    ['\u{1F4A2}', 'smileys:anger_symbol'],
    ['\u{2639}', 'smileys:plain_sad'],
    ['\u{263A}', 'smileys:plain_happy'],
    ['\u{2665}', 'smileys:heart/card_suit'],
    ['\u{2665}\u{FE0F}', 'smileys:heart/card_suit_red'],
    ['\u{1F5E3}', 'smileys:speaking_head'],
    ['\u{1F636}\u{200D}\u{1F32B}\u{FE0F}', 'smileys:face_in_clouds'],
    ['\u{1F642}\u{200D}\u{2194}\u{FE0F}', 'smileys:head_shaking_horizontally'],
    ['\u{1F642}\u{200D}\u{2195}\u{FE0F}', 'smileys:head_shaking_vertically'],
    ['\u{1FAE9}', 'smileys:face_with_bags_under_eyes'],
    ['\u{1FAE4}', 'smileys:face_with_diagonal_mouth'],
    ['\u{1F62E}', 'smileys:face_with_open_mouth'],
    ['\u{1F62F}', 'smileys:hushed_face'],
    ['\u{1F632}', 'smileys:astonished_face'],
    ['\u{1F616}', 'smileys:confounded_face'],
    ['\u{1F623}', 'smileys:persevering_face'],
    ['\u{1F61E}', 'smileys:disappointed_face'],
    ['\u{1F613}', 'smileys:downcast_face_with_sweat'],
    ['\u{1F629}', 'smileys:weary_face'],
    ['\u{1F62B}', 'smileys:tired_face'],
    ['\u{1F971}', 'smileys:yawning_face'],
    ['\u{1FA77}', 'smileys:heart/pink'],
    ['\u{1FA75}', 'smileys:heart/light_blue'],
    ['\u{1FA76}', 'smileys:heart/grey'],
    ['\u{1F441}\u{FE0F}\u{200D}\u{1F5E8}\u{FE0F}', 'smileys:eye_in_speech_bubble'],
    ['\u{1F5EF}\u{FE0F}', 'smileys:right_anger_bubble'],
    ['\u{1F44B}', 'people:hand/wave'],
    ['\u{1F91A}', 'people:hand/raised_back_of_hand'],
    ['\u{270B}', 'people:hand/raised_hand'],
    ['\u{1F596}', 'people:hand/vulcan_salute'],
    ['\u{1FAF1}', 'people:hand/rightwards_hand'],
    ['\u{1FAF2}', 'people:hand/leftwards_hand'],
    ['\u{1FAF3}', 'people:hand/palm_down_hand'],
    ['\u{1FAF4}', 'people:hand/palm_up_hand'],
    ['\u{1F44C}', 'people:hand/ok_hand'],
    ['\u{1F90C}', 'people:hand/pinched_fingers'],
    ['\u{1F90F}', 'people:hand/pinching_hand'],
    ['\u{270C}', 'people:hand/v'],
    ['\u{1F91E}', 'people:hand/crossed_fingers'],
    ['\u{1F91F}', 'people:hand/love_you_gesture'],
    ['\u{1F918}', 'people:hand/the_horns'],
    ['\u{1F919}', 'people:hand/call_me_hand'],
    ['\u{1F448}', 'people:hand/point_left'],
    ['\u{1F449}', 'people:hand/point_right'],
    ['\u{1F446}', 'people:hand/point_up_2'],
    ['\u{1F595}', 'people:hand/middle_finger'],
    ['\u{1F447}', 'people:hand/point_down'],
    ['\u{1F44D}', 'people:hand/thumbsup'],
    ['\u{1F44E}', 'people:hand/thumbsdown'],
    ['\u{270A}', 'people:hand/fist_raised'],
    ['\u{1F44A}', 'people:hand/fist_oncoming'],
    ['\u{1F91B}', 'people:hand/fist_left'],
    ['\u{1F91C}', 'people:hand/fist_right'],
    ['\u{1F44F}', 'people:hand/clap'],
    ['\u{1F64C}', 'people:hand/raised_hands'],
    ['\u{1F450}', 'people:hand/open_hands'],
    ['\u{1F932}', 'people:hand/palms_up_together'],
    ['\u{1F91D}', 'people:hand/handshake'],
    ['\u{1F64F}', 'people:hand/pray'],
    ['\u{270D}\u{FE0F}', 'people:hand/writing_hand'],
    ['\u{1F485}', 'people:hand/nail_care'],
    ['\u{1F933}', 'people:hand/selfie'],
    ['\u{1F4AA}', 'people:body/muscle'],
    ['\u{1F442}', 'people:body/ear'],
    ['\u{1F443}', 'people:body/nose'],
    ['\u{1F9E0}', 'people:body/brain'],
    ['\u{1FAC0}', 'people:body/anatomical_heart'],
    ['\u{1FAC1}', 'people:body/lungs'],
    ['\u{1F9B7}', 'people:body/tooth'],
    ['\u{1F9B4}', 'people:body/bone'],
    ['\u{1F440}', 'people:body/eyes'],
    ['\u{1F445}', 'people:body/tongue'],
    ['\u{1F444}', 'people:body/lips'],
    ['\u{1F464}', 'people:bust_in_silhouette'],
    ['\u{1F465}', 'people:busts_in_silhouette'],
    ['\u{1F466}', 'people:boy'],
    ['\u{1F467}', 'people:girl'],
    ['\u{1F468}', 'people:man'],
    ['\u{1F469}', 'people:woman'],
    ['\u{1F474}', 'people:older_man'],
    ['\u{1F475}', 'people:older_woman'],
    ['\u{1F9D1}', 'people:person'],
    ['\u{1F473}', 'people:man_with_turban'],
    ['\u{1F471}', 'people:person_with_blond_hair'],
    ['\u{1F934}', 'people:prince'],
    ['\u{1F470}', 'people:bride_with_veil'],
    ['\u{1F935}', 'people:man_in_tuxedo'],
    ['\u{1F478}', 'people:princess'],
    ['\u{1F472}', 'people:man_with_gua_pi_mao'],
    ['\u{1F46F}', 'people:woman_with_bunny_ears'],
    ['\u{1F46A}', 'people:family'],
    ['\u{1F48B}', 'people:kiss_mark'],
    ['\u{1F48C}', 'people:love_letter'],
    ['\u{1F48F}', 'people:kiss'],
    ['\u{1F491}', 'people:couple_with_heart'],
    ['\u{1F46B}', 'people:man_and_woman_holding_hands'],
    ['\u{1F46C}', 'people:two_men_holding_hands'],
    ['\u{1F46D}', 'people:two_women_holding_hands'],
    ['\u{1F590}\u{FE0F}', 'people:hand/with_fingers_splayed'],
    ['\u{1FAF7}', 'people:hand/leftwards_pushing_hand'],
    ['\u{1FAF8}', 'people:hand/rightwards_pushing_hand'],
    ['\u{270C}\u{FE0F}', 'people:hand/victory_hand'],
    ['\u{1FAF0}', 'people:hand/with_index_finger_and_thumb_crossed'],
    ['\u{261D}\u{FE0F}', 'people:hand/index_pointing_up'],
    ['\u{1FAF5}', 'people:hand/index_pointing_at_the_viewer'],
    ['\u{1FAF6}', 'people:hand/heart_hands'],
    ['\u{1F9BE}', 'people:body/mechanical_arm'],
    ['\u{1F9BF}', 'people:body/mechanical_leg'],
    ['\u{1F9B5}', 'people:body/leg'],
    ['\u{1F9B6}', 'people:body/foot'],
    ['\u{1F9BB}', 'people:body/ear_with_hearing_aid'],
    ['\u{1F441}\u{FE0F}', 'people:body/eye'],
    ['\u{1FAE6}', 'people:body/biting_lip'],
    ['\u{1F476}', 'people:person/baby'],
    ['\u{1F9D2}', 'people:person/child'],
    ['\u{1F9D4}', 'people:person/person_beard'],
    ['\u{1F9D4}\u{200D}\u{2642}\u{FE0F}', 'people:man_beard/man'],
    ['\u{1F9D4}\u{200D}\u{2640}\u{FE0F}', 'people:woman_beard/woman'],
    ['\u{1F471}\u{200D}\u{2640}\u{FE0F}', 'people:woman_blond_hair/woman'],
    ['\u{1F471}\u{200D}\u{2642}\u{FE0F}', 'people:man_blond_hair/man'],
    ['\u{1F9D3}', 'people:person/older_person'],
    ['\u{1F64D}', 'people:gesture/frowning'],
    ['\u{1F64D}\u{200D}\u{2642}\u{FE0F}', 'people:man_frowning/man'],
    ['\u{1F64D}\u{200D}\u{2640}\u{FE0F}', 'people:woman_frowning/woman'],
    ['\u{1F64E}', 'people:gesture/pouting'],
    ['\u{1F64E}\u{200D}\u{2642}\u{FE0F}', 'people:man_pouting/man'],
    ['\u{1F64E}\u{200D}\u{2640}\u{FE0F}', 'people:woman_pouting/woman'],
    ['\u{1F645}', 'people:gesture/gesturing_no'],
    ['\u{1F645}\u{200D}\u{2642}\u{FE0F}', 'people:man_gesturing_no/man'],
    ['\u{1F645}\u{200D}\u{2640}\u{FE0F}', 'people:woman_gesturing_no/woman'],
    ['\u{1F646}', 'people:gesture/gesturing_ok'],
    ['\u{1F646}\u{200D}\u{2642}\u{FE0F}', 'people:man_gesturing_ok/man'],
    ['\u{1F646}\u{200D}\u{2640}\u{FE0F}', 'people:woman_gesturing_ok/woman'],
    ['\u{1F481}', 'people:gesture/tipping_hand'],
    ['\u{1F481}\u{200D}\u{2642}\u{FE0F}', 'people:man_tipping_hand/man'],
    ['\u{1F481}\u{200D}\u{2640}\u{FE0F}', 'people:woman_tipping_hand/woman'],
    ['\u{1F64B}', 'people:gesture/raising_hand'],
    ['\u{1F64B}\u{200D}\u{2642}\u{FE0F}', 'people:man_raising_hand/man'],
    ['\u{1F64B}\u{200D}\u{2640}\u{FE0F}', 'people:woman_raising_hand/woman'],
    ['\u{1F9CF}', 'people:gesture/deaf_person'],
    ['\u{1F9CF}\u{200D}\u{2642}\u{FE0F}', 'people:deaf/man'],
    ['\u{1F9CF}\u{200D}\u{2640}\u{FE0F}', 'people:deaf/woman'],
    ['\u{1F647}', 'people:gesture/bowing'],
    ['\u{1F647}\u{200D}\u{2642}\u{FE0F}', 'people:man_bowing/man'],
    ['\u{1F647}\u{200D}\u{2640}\u{FE0F}', 'people:woman_bowing/woman'],
    ['\u{1F926}', 'people:gesture/facepalming'],
    ['\u{1F926}\u{200D}\u{2642}\u{FE0F}', 'people:man_facepalming/man'],
    ['\u{1F926}\u{200D}\u{2640}\u{FE0F}', 'people:woman_facepalming/woman'],
    ['\u{1F937}', 'people:gesture/shrugging'],
    ['\u{1F937}\u{200D}\u{2642}\u{FE0F}', 'people:man_shrugging/man'],
    ['\u{1F937}\u{200D}\u{2640}\u{FE0F}', 'people:woman_shrugging/woman'],
    ['\u{1F9D1}\u{200D}\u{2695}\u{FE0F}', 'people:health_worker'],
    ['\u{1F468}\u{200D}\u{2695}\u{FE0F}', 'people:health_worker/man'],
    ['\u{1F469}\u{200D}\u{2695}\u{FE0F}', 'people:health_worker/woman'],
    ['\u{1F9D1}\u{200D}\u{1F393}', 'people:student'],
    ['\u{1F468}\u{200D}\u{1F393}', 'people:student/man'],
    ['\u{1F469}\u{200D}\u{1F393}', 'people:student/woman'],
    ['\u{1F9D1}\u{200D}\u{1F3EB}', 'people:teacher'],
    ['\u{1F468}\u{200D}\u{1F3EB}', 'people:teacher/man'],
    ['\u{1F469}\u{200D}\u{1F3EB}', 'people:teacher/woman'],
    ['\u{1F9D1}\u{200D}\u{2696}\u{FE0F}', 'people:judge'],
    ['\u{1F468}\u{200D}\u{2696}\u{FE0F}', 'people:judge/man'],
    ['\u{1F469}\u{200D}\u{2696}\u{FE0F}', 'people:judge/woman'],
    ['\u{1F9D1}\u{200D}\u{1F33E}', 'people:farmer'],
    ['\u{1F468}\u{200D}\u{1F33E}', 'people:farmer/man'],
    ['\u{1F469}\u{200D}\u{1F33E}', 'people:farmer/woman'],
    ['\u{1F9D1}\u{200D}\u{1F373}', 'people:cook'],
    ['\u{1F468}\u{200D}\u{1F373}', 'people:cook/man'],
    ['\u{1F469}\u{200D}\u{1F373}', 'people:cook/woman'],
    ['\u{1F9D1}\u{200D}\u{1F527}', 'people:mechanic'],
    ['\u{1F468}\u{200D}\u{1F527}', 'people:mechanic/man'],
    ['\u{1F469}\u{200D}\u{1F527}', 'people:mechanic/woman'],
    ['\u{1F9D1}\u{200D}\u{1F3ED}', 'people:factory_worker'],
    ['\u{1F468}\u{200D}\u{1F3ED}', 'people:factory_worker/man'],
    ['\u{1F469}\u{200D}\u{1F3ED}', 'people:factory_worker/woman'],
    ['\u{1F9D1}\u{200D}\u{1F4BC}', 'people:office_worker'],
    ['\u{1F468}\u{200D}\u{1F4BC}', 'people:office_worker/man'],
    ['\u{1F469}\u{200D}\u{1F4BC}', 'people:office_worker/woman'],
    ['\u{1F9D1}\u{200D}\u{1F52C}', 'people:scientist'],
    ['\u{1F468}\u{200D}\u{1F52C}', 'people:scientist/man'],
    ['\u{1F469}\u{200D}\u{1F52C}', 'people:scientist/woman'],
    ['\u{1F9D1}\u{200D}\u{1F4BB}', 'people:technologist'],
    ['\u{1F468}\u{200D}\u{1F4BB}', 'people:technologist/man'],
    ['\u{1F469}\u{200D}\u{1F4BB}', 'people:technologist/woman'],
    ['\u{1F9D1}\u{200D}\u{1F3A4}', 'people:singer'],
    ['\u{1F468}\u{200D}\u{1F3A4}', 'people:singer/man'],
    ['\u{1F469}\u{200D}\u{1F3A4}', 'people:singer/woman'],
    ['\u{1F9D1}\u{200D}\u{1F3A8}', 'people:artist'],
    ['\u{1F468}\u{200D}\u{1F3A8}', 'people:artist/man'],
    ['\u{1F469}\u{200D}\u{1F3A8}', 'people:artist/woman'],
    ['\u{1F9D1}\u{200D}\u{2708}\u{FE0F}', 'people:pilot'],
    ['\u{1F468}\u{200D}\u{2708}\u{FE0F}', 'people:pilot/man'],
    ['\u{1F469}\u{200D}\u{2708}\u{FE0F}', 'people:pilot/woman'],
    ['\u{1F9D1}\u{200D}\u{1F680}', 'people:astronaut'],
    ['\u{1F468}\u{200D}\u{1F680}', 'people:astronaut/man'],
    ['\u{1F469}\u{200D}\u{1F680}', 'people:astronaut/woman'],
    ['\u{1F9D1}\u{200D}\u{1F692}', 'people:firefighter'],
    ['\u{1F468}\u{200D}\u{1F692}', 'people:firefighter/man'],
    ['\u{1F469}\u{200D}\u{1F692}', 'people:firefighter/woman'],
    ['\u{1F46E}', 'people:role/police_officer'],
    ['\u{1F46E}\u{200D}\u{2642}\u{FE0F}', 'people:man_police_officer/man'],
    ['\u{1F46E}\u{200D}\u{2640}\u{FE0F}', 'people:woman_police_officer/woman'],
    ['\u{1F575}\u{FE0F}', 'people:role/detective'],
    ['\u{1F575}\u{FE0F}\u{200D}\u{2642}\u{FE0F}', 'people:man_detective/man'],
    ['\u{1F575}\u{FE0F}\u{200D}\u{2640}\u{FE0F}', 'people:woman_detective/woman'],
    ['\u{1F482}', 'people:role/guard'],
    ['\u{1F482}\u{200D}\u{2642}\u{FE0F}', 'people:man_guard/man'],
    ['\u{1F482}\u{200D}\u{2640}\u{FE0F}', 'people:woman_guard/woman'],
    ['\u{1F977}', 'people:role/ninja'],
    ['\u{1F477}', 'people:role/construction_worker'],
    ['\u{1F477}\u{200D}\u{2642}\u{FE0F}', 'people:man_construction_worker/man'],
    ['\u{1F477}\u{200D}\u{2640}\u{FE0F}', 'people:woman_construction_worker/woman'],
    ['\u{1FAC5}', 'people:role/with_crown'],
    ['\u{1F473}\u{200D}\u{2642}\u{FE0F}', 'people:man_wearing_turban/man'],
    ['\u{1F473}\u{200D}\u{2640}\u{FE0F}', 'people:woman_wearing_turban/woman'],
    ['\u{1F9D5}', 'people:role/woman_with_headscarf'],
    ['\u{1F935}\u{200D}\u{2642}\u{FE0F}', 'people:man_in_tuxedo/man'],
    ['\u{1F935}\u{200D}\u{2640}\u{FE0F}', 'people:woman_in_tuxedo/woman'],
    ['\u{1F470}\u{200D}\u{2642}\u{FE0F}', 'people:man_with_veil/man'],
    ['\u{1F470}\u{200D}\u{2640}\u{FE0F}', 'people:woman_with_veil/woman'],
    ['\u{1F930}', 'people:role/pregnant_woman'],
    ['\u{1FAC3}', 'people:role/pregnant_man'],
    ['\u{1FAC4}', 'people:role/pregnant_person'],
    ['\u{1F931}', 'people:role/breast_feeding'],
    ['\u{1F469}\u{200D}\u{1F37C}', 'people:feeding_baby/woman'],
    ['\u{1F468}\u{200D}\u{1F37C}', 'people:feeding_baby/man'],
    ['\u{1F9D1}\u{200D}\u{1F37C}', 'people:feeding_baby'],
    ['\u{1F47C}', 'people:fantasy/baby_angel'],
    ['\u{1F936}', 'people:fantasy/mrs_claus'],
    ['\u{1F9D1}\u{200D}\u{1F384}', 'people:mx_claus'],
    ['\u{1F9B8}', 'people:fantasy/superhero'],
    ['\u{1F9B8}\u{200D}\u{2642}\u{FE0F}', 'people:man_superhero/man'],
    ['\u{1F9B8}\u{200D}\u{2640}\u{FE0F}', 'people:woman_superhero/woman'],
    ['\u{1F9B9}', 'people:fantasy/supervillain'],
    ['\u{1F9B9}\u{200D}\u{2642}\u{FE0F}', 'people:man_supervillain/man'],
    ['\u{1F9B9}\u{200D}\u{2640}\u{FE0F}', 'people:woman_supervillain/woman'],
    ['\u{1F9D9}', 'people:fantasy/mage'],
    ['\u{1F9D9}\u{200D}\u{2642}\u{FE0F}', 'people:man_mage/man'],
    ['\u{1F9D9}\u{200D}\u{2640}\u{FE0F}', 'people:woman_mage/woman'],
    ['\u{1F9DA}', 'people:fantasy/fairy'],
    ['\u{1F9DA}\u{200D}\u{2642}\u{FE0F}', 'people:man_fairy/man'],
    ['\u{1F9DA}\u{200D}\u{2640}\u{FE0F}', 'people:woman_fairy/woman'],
    ['\u{1F9DB}', 'people:fantasy/vampire'],
    ['\u{1F9DB}\u{200D}\u{2642}\u{FE0F}', 'people:man_vampire/man'],
    ['\u{1F9DB}\u{200D}\u{2640}\u{FE0F}', 'people:woman_vampire/woman'],
    ['\u{1F9DC}', 'people:fantasy/merperson'],
    ['\u{1F9DC}\u{200D}\u{2642}\u{FE0F}', 'people:mer/man'],
    ['\u{1F9DC}\u{200D}\u{2640}\u{FE0F}', 'people:mermaid/woman'],
    ['\u{1F9DD}', 'people:fantasy/elf'],
    ['\u{1F9DD}\u{200D}\u{2642}\u{FE0F}', 'people:man_elf/man'],
    ['\u{1F9DD}\u{200D}\u{2640}\u{FE0F}', 'people:woman_elf/woman'],
    ['\u{1F9DE}', 'people:fantasy/genie'],
    ['\u{1F9DE}\u{200D}\u{2642}\u{FE0F}', 'people:man_genie/man'],
    ['\u{1F9DE}\u{200D}\u{2640}\u{FE0F}', 'people:woman_genie/woman'],
    ['\u{1F9DF}', 'people:fantasy/zombie'],
    ['\u{1F9DF}\u{200D}\u{2642}\u{FE0F}', 'people:man_zombie/man'],
    ['\u{1F9DF}\u{200D}\u{2640}\u{FE0F}', 'people:woman_zombie/woman'],
    ['\u{1F486}', 'people:activity/getting_massage'],
    ['\u{1F486}\u{200D}\u{2642}\u{FE0F}', 'people:man_getting_massage/man'],
    ['\u{1F486}\u{200D}\u{2640}\u{FE0F}', 'people:woman_getting_massage/woman'],
    ['\u{1F487}', 'people:activity/getting_haircut'],
    ['\u{1F487}\u{200D}\u{2642}\u{FE0F}', 'people:man_getting_haircut/man'],
    ['\u{1F487}\u{200D}\u{2640}\u{FE0F}', 'people:woman_getting_haircut/woman'],
    ['\u{1F6B6}\u{200D}\u{2642}\u{FE0F}', 'people:man_walking/man'],
    ['\u{1F6B6}\u{200D}\u{2640}\u{FE0F}', 'people:woman_walking/woman'],
    ['\u{1F6B6}\u{200D}\u{27A1}\u{FE0F}', 'people:person_walking_facing_right'],
    ['\u{1F6B6}\u{200D}\u{2640}\u{FE0F}\u{200D}\u{27A1}\u{FE0F}', 'people:woman_walking_facing_right'],
    ['\u{1F6B6}\u{200D}\u{2642}\u{FE0F}\u{200D}\u{27A1}\u{FE0F}', 'people:man_walking_facing_right'],
    ['\u{1F9CD}', 'people:activity/standing'],
    ['\u{1F9CD}\u{200D}\u{2642}\u{FE0F}', 'people:man_standing/man'],
    ['\u{1F9CD}\u{200D}\u{2640}\u{FE0F}', 'people:woman_standing/woman'],
    ['\u{1F9CE}', 'people:activity/kneeling'],
    ['\u{1F9CE}\u{200D}\u{2642}\u{FE0F}', 'people:man_kneeling/man'],
    ['\u{1F9CE}\u{200D}\u{2640}\u{FE0F}', 'people:woman_kneeling/woman'],
    ['\u{1F9CE}\u{200D}\u{27A1}\u{FE0F}', 'people:person_kneeling_facing_right'],
    ['\u{1F9CE}\u{200D}\u{2640}\u{FE0F}\u{200D}\u{27A1}\u{FE0F}', 'people:woman_kneeling_facing_right'],
    ['\u{1F9CE}\u{200D}\u{2642}\u{FE0F}\u{200D}\u{27A1}\u{FE0F}', 'people:man_kneeling_facing_right'],
    ['\u{1F9D1}\u{200D}\u{1F9AF}', 'people:with_white_cane'],
    ['\u{1F9D1}\u{200D}\u{1F9AF}\u{200D}\u{27A1}\u{FE0F}', 'people:with_white_cane_facing_right'],
    ['\u{1F468}\u{200D}\u{1F9AF}', 'people:with_white_cane/man'],
    ['\u{1F468}\u{200D}\u{1F9AF}\u{200D}\u{27A1}\u{FE0F}', 'people:with_white_cane_facing_right/man'],
    ['\u{1F469}\u{200D}\u{1F9AF}', 'people:with_white_cane/woman'],
    ['\u{1F469}\u{200D}\u{1F9AF}\u{200D}\u{27A1}\u{FE0F}', 'people:with_white_cane_facing_right/woman'],
    ['\u{1F9D1}\u{200D}\u{1F9BC}', 'people:in_motorized_wheelchair'],
    ['\u{1F9D1}\u{200D}\u{1F9BC}\u{200D}\u{27A1}\u{FE0F}', 'people:in_motorized_wheelchair_facing_right'],
    ['\u{1F468}\u{200D}\u{1F9BC}', 'people:in_motorized_wheelchair/man'],
    ['\u{1F468}\u{200D}\u{1F9BC}\u{200D}\u{27A1}\u{FE0F}', 'people:in_motorized_wheelchair_facing_right/man'],
    ['\u{1F469}\u{200D}\u{1F9BC}', 'people:in_motorized_wheelchair/woman'],
    ['\u{1F469}\u{200D}\u{1F9BC}\u{200D}\u{27A1}\u{FE0F}', 'people:in_motorized_wheelchair_facing_right/woman'],
    ['\u{1F9D1}\u{200D}\u{1F9BD}', 'people:in_manual_wheelchair'],
    ['\u{1F9D1}\u{200D}\u{1F9BD}\u{200D}\u{27A1}\u{FE0F}', 'people:in_manual_wheelchair_facing_right'],
    ['\u{1F468}\u{200D}\u{1F9BD}', 'people:in_manual_wheelchair/man'],
    ['\u{1F468}\u{200D}\u{1F9BD}\u{200D}\u{27A1}\u{FE0F}', 'people:in_manual_wheelchair_facing_right/man'],
    ['\u{1F469}\u{200D}\u{1F9BD}', 'people:in_manual_wheelchair/woman'],
    ['\u{1F469}\u{200D}\u{1F9BD}\u{200D}\u{27A1}\u{FE0F}', 'people:in_manual_wheelchair_facing_right/woman'],
    ['\u{1F3C3}\u{200D}\u{2642}\u{FE0F}', 'people:man_running/man'],
    ['\u{1F3C3}\u{200D}\u{2640}\u{FE0F}', 'people:woman_running/woman'],
    ['\u{1F3C3}\u{200D}\u{27A1}\u{FE0F}', 'people:person_running_facing_right'],
    ['\u{1F3C3}\u{200D}\u{2640}\u{FE0F}\u{200D}\u{27A1}\u{FE0F}', 'people:woman_running_facing_right'],
    ['\u{1F3C3}\u{200D}\u{2642}\u{FE0F}\u{200D}\u{27A1}\u{FE0F}', 'people:man_running_facing_right'],
    ['\u{1F483}', 'people:activity/woman_dancing'],
    ['\u{1F57A}', 'people:activity/man_dancing'],
    ['\u{1F46F}\u{200D}\u{2642}\u{FE0F}', 'people:men_with_bunny_ears/man'],
    ['\u{1F46F}\u{200D}\u{2640}\u{FE0F}', 'people:women_with_bunny_ears/woman'],
    ['\u{1F9D6}', 'people:activity/in_steamy_room'],
    ['\u{1F9D6}\u{200D}\u{2642}\u{FE0F}', 'people:man_in_steamy_room/man'],
    ['\u{1F9D6}\u{200D}\u{2640}\u{FE0F}', 'people:woman_in_steamy_room/woman'],
    ['\u{1F9D7}', 'people:activity/climbing'],
    ['\u{1F9D7}\u{200D}\u{2642}\u{FE0F}', 'people:man_climbing/man'],
    ['\u{1F9D7}\u{200D}\u{2640}\u{FE0F}', 'people:woman_climbing/woman'],
    ['\u{1F93A}', 'people:sport/fencing'],
    ['\u{1F3CC}\u{FE0F}\u{200D}\u{2642}\u{FE0F}', 'people:man_golfing/man'],
    ['\u{1F3CC}\u{FE0F}\u{200D}\u{2640}\u{FE0F}', 'people:woman_golfing/woman'],
    ['\u{1F3C4}\u{200D}\u{2642}\u{FE0F}', 'people:man_surfing/man'],
    ['\u{1F3C4}\u{200D}\u{2640}\u{FE0F}', 'people:woman_surfing/woman'],
    ['\u{1F6A3}', 'people:sport/rowing_boat'],
    ['\u{1F6A3}\u{200D}\u{2642}\u{FE0F}', 'people:man_rowing_boat/man'],
    ['\u{1F6A3}\u{200D}\u{2640}\u{FE0F}', 'people:woman_rowing_boat/woman'],
    ['\u{1F3CA}\u{200D}\u{2642}\u{FE0F}', 'people:man_swimming/man'],
    ['\u{1F3CA}\u{200D}\u{2640}\u{FE0F}', 'people:woman_swimming/woman'],
    ['\u{26F9}\u{FE0F}\u{200D}\u{2642}\u{FE0F}', 'people:man_bouncing_ball/man'],
    ['\u{26F9}\u{FE0F}\u{200D}\u{2640}\u{FE0F}', 'people:woman_bouncing_ball/woman'],
    ['\u{1F3CB}\u{FE0F}\u{200D}\u{2642}\u{FE0F}', 'people:man_lifting_weights/man'],
    ['\u{1F3CB}\u{FE0F}\u{200D}\u{2640}\u{FE0F}', 'people:woman_lifting_weights/woman'],
    ['\u{1F6B4}\u{200D}\u{2642}\u{FE0F}', 'people:man_biking/man'],
    ['\u{1F6B4}\u{200D}\u{2640}\u{FE0F}', 'people:woman_biking/woman'],
    ['\u{1F6B5}\u{200D}\u{2642}\u{FE0F}', 'people:man_mountain_biking/man'],
    ['\u{1F6B5}\u{200D}\u{2640}\u{FE0F}', 'people:woman_mountain_biking/woman'],
    ['\u{1F938}', 'people:sport/cartwheeling'],
    ['\u{1F938}\u{200D}\u{2642}\u{FE0F}', 'people:man_cartwheeling/man'],
    ['\u{1F938}\u{200D}\u{2640}\u{FE0F}', 'people:woman_cartwheeling/woman'],
    ['\u{1F93C}', 'people:sport/people_wrestling'],
    ['\u{1F93C}\u{200D}\u{2642}\u{FE0F}', 'people:men_wrestling/man'],
    ['\u{1F93C}\u{200D}\u{2640}\u{FE0F}', 'people:women_wrestling/woman'],
    ['\u{1F93D}', 'people:sport/playing_water_polo'],
    ['\u{1F93D}\u{200D}\u{2642}\u{FE0F}', 'people:man_playing_water_polo/man'],
    ['\u{1F93D}\u{200D}\u{2640}\u{FE0F}', 'people:woman_playing_water_polo/woman'],
    ['\u{1F93E}', 'people:sport/playing_handball'],
    ['\u{1F93E}\u{200D}\u{2642}\u{FE0F}', 'people:man_playing_handball/man'],
    ['\u{1F93E}\u{200D}\u{2640}\u{FE0F}', 'people:woman_playing_handball/woman'],
    ['\u{1F939}', 'people:sport/juggling'],
    ['\u{1F939}\u{200D}\u{2642}\u{FE0F}', 'people:man_juggling/man'],
    ['\u{1F939}\u{200D}\u{2640}\u{FE0F}', 'people:woman_juggling/woman'],
    ['\u{1F9D8}', 'people:rest/in_lotus_position'],
    ['\u{1F9D8}\u{200D}\u{2642}\u{FE0F}', 'people:man_in_lotus_position/man'],
    ['\u{1F9D8}\u{200D}\u{2640}\u{FE0F}', 'people:woman_in_lotus_position/woman'],
    ['\u{1F9D1}\u{200D}\u{1F91D}\u{200D}\u{1F9D1}', 'people:people_holding_hands'],
    ['\u{1F469}\u{200D}\u{2764}\u{FE0F}\u{200D}\u{1F48B}\u{200D}\u{1F468}', 'people:kiss_woman_man/woman'],
    ['\u{1F468}\u{200D}\u{2764}\u{FE0F}\u{200D}\u{1F48B}\u{200D}\u{1F468}', 'people:kiss_man_man/man'],
    ['\u{1F469}\u{200D}\u{2764}\u{FE0F}\u{200D}\u{1F48B}\u{200D}\u{1F469}', 'people:kiss_woman_woman/woman'],
    ['\u{1F469}\u{200D}\u{2764}\u{FE0F}\u{200D}\u{1F468}', 'people:couple_with_heart_woman_man/woman'],
    ['\u{1F468}\u{200D}\u{2764}\u{FE0F}\u{200D}\u{1F468}', 'people:couple_with_heart_man_man/man'],
    ['\u{1F469}\u{200D}\u{2764}\u{FE0F}\u{200D}\u{1F469}', 'people:couple_with_heart_woman_woman/woman'],
    ['\u{1F468}\u{200D}\u{1F469}\u{200D}\u{1F466}', 'people:family/man_woman_boy'],
    ['\u{1F468}\u{200D}\u{1F469}\u{200D}\u{1F467}', 'people:family/man_woman_girl'],
    ['\u{1F468}\u{200D}\u{1F469}\u{200D}\u{1F467}\u{200D}\u{1F466}', 'people:family/man_woman_girl_boy'],
    ['\u{1F468}\u{200D}\u{1F469}\u{200D}\u{1F466}\u{200D}\u{1F466}', 'people:family/man_woman_boy_boy'],
    ['\u{1F468}\u{200D}\u{1F469}\u{200D}\u{1F467}\u{200D}\u{1F467}', 'people:family/man_woman_girl_girl'],
    ['\u{1F468}\u{200D}\u{1F468}\u{200D}\u{1F466}', 'people:family/man_man_boy'],
    ['\u{1F468}\u{200D}\u{1F468}\u{200D}\u{1F467}', 'people:family/man_man_girl'],
    ['\u{1F468}\u{200D}\u{1F468}\u{200D}\u{1F467}\u{200D}\u{1F466}', 'people:family/man_man_girl_boy'],
    ['\u{1F468}\u{200D}\u{1F468}\u{200D}\u{1F466}\u{200D}\u{1F466}', 'people:family/man_man_boy_boy'],
    ['\u{1F468}\u{200D}\u{1F468}\u{200D}\u{1F467}\u{200D}\u{1F467}', 'people:family/man_man_girl_girl'],
    ['\u{1F469}\u{200D}\u{1F469}\u{200D}\u{1F466}', 'people:family/woman_woman_boy'],
    ['\u{1F469}\u{200D}\u{1F469}\u{200D}\u{1F467}', 'people:family/woman_woman_girl'],
    ['\u{1F469}\u{200D}\u{1F469}\u{200D}\u{1F467}\u{200D}\u{1F466}', 'people:family/woman_woman_girl_boy'],
    ['\u{1F469}\u{200D}\u{1F469}\u{200D}\u{1F466}\u{200D}\u{1F466}', 'people:family/woman_woman_boy_boy'],
    ['\u{1F469}\u{200D}\u{1F469}\u{200D}\u{1F467}\u{200D}\u{1F467}', 'people:family/woman_woman_girl_girl'],
    ['\u{1F468}\u{200D}\u{1F466}', 'people:family/man_boy'],
    ['\u{1F468}\u{200D}\u{1F466}\u{200D}\u{1F466}', 'people:family/man_boy_boy'],
    ['\u{1F468}\u{200D}\u{1F467}', 'people:family/man_girl'],
    ['\u{1F468}\u{200D}\u{1F467}\u{200D}\u{1F466}', 'people:family/man_girl_boy'],
    ['\u{1F468}\u{200D}\u{1F467}\u{200D}\u{1F467}', 'people:family/man_girl_girl'],
    ['\u{1F469}\u{200D}\u{1F466}', 'people:family/woman_boy'],
    ['\u{1F469}\u{200D}\u{1F466}\u{200D}\u{1F466}', 'people:family/woman_boy_boy'],
    ['\u{1F469}\u{200D}\u{1F467}', 'people:family/woman_girl'],
    ['\u{1F469}\u{200D}\u{1F467}\u{200D}\u{1F466}', 'people:family/woman_girl_boy'],
    ['\u{1F469}\u{200D}\u{1F467}\u{200D}\u{1F467}', 'people:family/woman_girl_girl'],
    ['\u{1FAC2}', 'people:people_hugging'],
    ['\u{1F9D1}\u{200D}\u{1F9D1}\u{200D}\u{1F9D2}', 'people:family/adult_adult_child'],
    ['\u{1F9D1}\u{200D}\u{1F9D1}\u{200D}\u{1F9D2}\u{200D}\u{1F9D2}', 'people:family/adult_adult_child_child'],
    ['\u{1F9D1}\u{200D}\u{1F9D2}', 'people:family/adult_child'],
    ['\u{1F9D1}\u{200D}\u{1F9D2}\u{200D}\u{1F9D2}', 'people:family/adult_child_child'],
    ['\u{1F463}', 'people:footprints'],
    ['\u{1FAC6}', 'people:fingerprint'],
    ['\u{1F435}', 'nature:monkey_face'],
    ['\u{1F412}', 'nature:monkey'],
    ['\u{1F98D}', 'nature:gorilla'],
    ['\u{1F9A7}', 'nature:orangutan'],
    ['\u{1F436}', 'nature:dog_face'],
    ['\u{1F415}', 'nature:dog'],
    ['\u{1F9AE}', 'nature:guide_dog'],
    ['\u{1F415}\u{200D}\u{1F9AE}', 'nature:service_dog'],
    ['\u{1F415}\u{200D}\u{1F9BA}', 'nature:service_dog'],
    ['\u{1F429}', 'nature:poodle'],
    ['\u{1F43A}', 'nature:wolf'],
    ['\u{1F98A}', 'nature:fox'],
    ['\u{1F99D}', 'nature:raccoon'],
    ['\u{1F431}', 'nature:cat_face'],
    ['\u{1F408}', 'nature:cat'],
    ['\u{1F408}\u{200D}\u{2B1B}', 'nature:black_cat'],
    ['\u{1F42F}', 'nature:tiger_face'],
    ['\u{1F405}', 'nature:tiger'],
    ['\u{1F406}', 'nature:leopard'],
    ['\u{1F434}', 'nature:horse_face'],
    ['\u{1F40E}', 'nature:horse'],
    ['\u{1F984}', 'nature:unicorn'],
    ['\u{1F993}', 'nature:zebra'],
    ['\u{1F404}', 'nature:cow'],
    ['\u{1F437}', 'nature:pig_face'],
    ['\u{1F416}', 'nature:pig'],
    ['\u{1F417}', 'nature:boar'],
    ['\u{1F43D}', 'nature:pig_nose'],
    ['\u{1F40F}', 'nature:ram'],
    ['\u{1F411}', 'nature:sheep'],
    ['\u{1F410}', 'nature:goat'],
    ['\u{1F42A}', 'nature:dromedary_camel'],
    ['\u{1F42B}', 'nature:camel'],
    ['\u{1F999}', 'nature:llama'],
    ['\u{1F992}', 'nature:giraffe'],
    ['\u{1F418}', 'nature:elephant'],
    ['\u{1F9A3}', 'nature:mammoth'],
    ['\u{1F98F}', 'nature:rhinoceros'],
    ['\u{1F99B}', 'nature:hippopotamus'],
    ['\u{1F42D}', 'nature:mouse_face'],
    ['\u{1F401}', 'nature:mouse'],
    ['\u{1F400}', 'nature:rat'],
    ['\u{1F439}', 'nature:hamster'],
    ['\u{1F430}', 'nature:rabbit_face'],
    ['\u{1F407}', 'nature:rabbit'],
    ['\u{1F43F}\u{FE0F}', 'nature:chipmunk'],
    ['\u{1F9AB}', 'nature:beaver'],
    ['\u{1F9A1}', 'nature:badger'],
    ['\u{1F9A6}', 'nature:otter'],
    ['\u{1F9A8}', 'nature:skunk'],
    ['\u{1F998}', 'nature:kangaroo'],
    ['\u{1F9A5}', 'nature:sloth'],
    ['\u{1F43B}', 'nature:bear'],
    ['\u{1F43B}\u{200D}\u{2744}\u{FE0F}', 'nature:polar_bear'],
    ['\u{1F428}', 'nature:koala'],
    ['\u{1F43C}', 'nature:panda'],
    ['\u{1F43E}', 'nature:paw_prints'],
    ['\u{1F994}', 'nature:hedgehog'],
    ['\u{1F983}', 'nature:turkey'],
    ['\u{1F414}', 'nature:chicken'],
    ['\u{1F413}', 'nature:rooster'],
    ['\u{1F423}', 'nature:hatching_chick'],
    ['\u{1F424}', 'nature:baby_chick'],
    ['\u{1F425}', 'nature:front_facing_baby_chick'],
    ['\u{1F426}', 'nature:bird'],
    ['\u{1F427}', 'nature:penguin'],
    ['\u{1F54A}\u{FE0F}', 'nature:dove'],
    ['\u{1F985}', 'nature:eagle'],
    ['\u{1F986}', 'nature:duck'],
    ['\u{1F9A2}', 'nature:swan'],
    ['\u{1F989}', 'nature:owl'],
    ['\u{1F9A4}', 'nature:dodo'],
    ['\u{1FAB6}', 'nature:feather'],
    ['\u{1F9A9}', 'nature:flamingo'],
    ['\u{1F99A}', 'nature:peacock'],
    ['\u{1F40A}', 'nature:crocodile'],
    ['\u{1F422}', 'nature:turtle'],
    ['\u{1F98E}', 'nature:lizard'],
    ['\u{1F40D}', 'nature:snake'],
    ['\u{1F432}', 'nature:dragon_face'],
    ['\u{1F409}', 'nature:dragon'],
    ['\u{1F995}', 'nature:sauropod'],
    ['\u{1F996}', 'nature:t_rex'],
    ['\u{1F438}', 'nature:frog'],
    ['\u{1F433}', 'nature:spouting_whale'],
    ['\u{1F40B}', 'nature:whale'],
    ['\u{1F42C}', 'nature:dolphin'],
    ['\u{1F9AD}', 'nature:seal'],
    ['\u{1F41F}', 'nature:fish'],
    ['\u{1F420}', 'nature:tropical_fish'],
    ['\u{1F421}', 'nature:blowfish'],
    ['\u{1F988}', 'nature:shark'],
    ['\u{1F419}', 'nature:octopus'],
    ['\u{1F41A}', 'nature:spiral_shell'],
    ['\u{1F41B}', 'nature:bug'],
    ['\u{1F41C}', 'nature:ant'],
    ['\u{1F41D}', 'nature:honeybee'],
    ['\u{1F41E}', 'nature:ladybug'],
    ['\u{1F997}', 'nature:cricket'],
    ['\u{1F577}\u{FE0F}', 'nature:spider'],
    ['\u{1F578}\u{FE0F}', 'nature:spider_web'],
    ['\u{1F98B}', 'nature:butterfly'],
    ['\u{1F9A0}', 'nature:microbe'],
    ['\u{1FAB0}', 'nature:fly'],
    ['\u{1FAB1}', 'nature:worm'],
    ['\u{1FAB2}', 'nature:beetle'],
    ['\u{1FAB3}', 'nature:cockroach'],
    ['\u{1F982}', 'nature:scorpion'],
    ['\u{1FABC}', 'nature:jellyfish'],
    ['\u{1FAB8}', 'nature:coral'],
    ['\u{1F490}', 'nature:bouquet'],
    ['\u{1F338}', 'nature:cherry_blossom'],
    ['\u{1F4AE}', 'nature:white_flower'],
    ['\u{1F339}', 'nature:rose'],
    ['\u{1F33A}', 'nature:hibiscus'],
    ['\u{1F33B}', 'nature:sunflower'],
    ['\u{1F33C}', 'nature:blossom'],
    ['\u{1F337}', 'nature:tulip'],
    ['\u{1F331}', 'nature:seedling'],
    ['\u{1F332}', 'nature:evergreen_tree'],
    ['\u{1F333}', 'nature:deciduous_tree'],
    ['\u{1F334}', 'nature:palm_tree'],
    ['\u{1F335}', 'nature:cactus'],
    ['\u{1F33E}', 'nature:sheaf_of_rice'],
    ['\u{1F33F}', 'nature:herb'],
    ['\u{1F340}', 'nature:four_leaf_clover'],
    ['\u{1F341}', 'nature:maple_leaf'],
    ['\u{1F342}', 'nature:fallen_leaf'],
    ['\u{1F343}', 'nature:leaf_fluttering_in_wind'],
    ['\u{1F344}', 'nature:mushroom'],
    ['\u{1F940}', 'nature:wilted_flower'],
    ['\u{1FAB7}', 'nature:lotus'],
    ['\u{1FAB4}', 'nature:potted_plant'],
    ['\u{1FAB5}', 'nature:wood'],
    ['\u{1F311}', 'nature:moon/new'],
    ['\u{1F312}', 'nature:moon/waxing_crescent'],
    ['\u{1F313}', 'nature:moon/first_quarter'],
    ['\u{1F314}', 'nature:moon/waxing_gibbous'],
    ['\u{1F315}', 'nature:moon/full'],
    ['\u{1F316}', 'nature:moon/waning_gibbous'],
    ['\u{1F317}', 'nature:moon/last_quarter'],
    ['\u{1F318}', 'nature:moon/waning_crescent'],
    ['\u{1F319}', 'nature:moon/crescent'],
    ['\u{1F31A}', 'nature:moon/new_with_face'],
    ['\u{1F31B}', 'nature:moon/first_quarter_face'],
    ['\u{1F31C}', 'nature:moon/last_quarter_face'],
    ['\u{2600}\u{FE0F}', 'nature:sun'],
    ['\u{1F31D}', 'nature:sun/with_face'],
    ['\u{1F31E}', 'nature:moon/full_with_face'],
    ['\u{2B50}', 'nature:astro/star'],
    ['\u{1F31F}', 'nature:astro/glowing_star'],
    ['\u{1F320}', 'nature:astro/shooting_star'],
    ['\u{1F30C}', 'nature:astro/milky_way'],
    ['\u{2604}\u{FE0F}', 'nature:astro/comet'],
    ['\u{2601}\u{FE0F}', 'nature:cloud'],
    ['\u{26C5}', 'nature:sun/behind_cloud'],
    ['\u{26C8}\u{FE0F}', 'nature:cloud/lightning_and_rain'],
    ['\u{1F324}\u{FE0F}', 'nature:sun/behind_small_cloud'],
    ['\u{1F325}\u{FE0F}', 'nature:sun/behind_large_cloud'],
    ['\u{1F326}\u{FE0F}', 'nature:sun/behind_rain_cloud'],
    ['\u{1F327}\u{FE0F}', 'nature:cloud/rain'],
    ['\u{1F328}\u{FE0F}', 'nature:cloud/snow'],
    ['\u{1F329}\u{FE0F}', 'nature:cloud/lightning'],
    ['\u{1F32A}\u{FE0F}', 'nature:tornado'],
    ['\u{1F32B}\u{FE0F}', 'nature:fog'],
    ['\u{1F32C}\u{FE0F}', 'nature:wind_face'],
    ['\u{1F300}', 'nature:cyclone'],
    ['\u{1F308}', 'nature:rainbow'],
    ['\u{1F302}', 'nature:umbrella/closed'],
    ['\u{2614}', 'nature:umbrella/rain_drops'],
    ['\u{2617}\u{FE0F}', 'nature:umbrella'],
    ['\u{26A1}', 'nature:high_voltage'],
    ['\u{2744}\u{FE0F}', 'nature:snowflake'],
    ['\u{2603}\u{FE0F}', 'nature:snowman'],
    ['\u{26C4}', 'nature:snowman/without_snow'],
    ['\u{1F525}', 'nature:fire'],
    ['\u{1F4A7}', 'nature:droplet'],
    ['\u{1F30A}', 'nature:water_wave'],
    ['\u{1F981}', 'nature:lion'],
    ['\u{1FACE}', 'nature:moose'],
    ['\u{1FACF}', 'nature:donkey'],
    ['\u{1F98C}', 'nature:deer'],
    ['\u{1F9AC}', 'nature:bison'],
    ['\u{1F42E}', 'nature:cow_face'],
    ['\u{1F402}', 'nature:ox'],
    ['\u{1F403}', 'nature:water_buffalo'],
    ['\u{1F987}', 'nature:bat'],
    ['\u{1F99C}', 'nature:parrot'],
    ['\u{1FABD}', 'nature:wing'],
    ['\u{1F426}\u{200D}\u{2B1B}', 'nature:black_bird'],
    ['\u{1FABF}', 'nature:goose'],
    ['\u{1F426}\u{200D}\u{1F525}', 'nature:phoenix'],
    ['\u{1F980}', 'nature:crab'],
    ['\u{1F99E}', 'nature:lobster'],
    ['\u{1F990}', 'nature:shrimp'],
    ['\u{1F991}', 'nature:squid'],
    ['\u{1F9AA}', 'nature:oyster'],
    ['\u{1F40C}', 'nature:snail'],
    ['\u{1F99F}', 'nature:mosquito'],
    ['\u{1F3F5}\u{FE0F}', 'nature:rosette'],
    ['\u{1FABB}', 'nature:hyacinth'],
    ['\u{2618}\u{FE0F}', 'nature:shamrock'],
    ['\u{1FAB9}', 'nature:empty_nest'],
    ['\u{1FABA}', 'nature:nest_with_eggs'],
    ['\u{1FABE}', 'nature:leafless_tree'],
    ['\u{1F347}', 'food:grapes'],
    ['\u{1F348}', 'food:melon'],
    ['\u{1F349}', 'food:watermelon'],
    ['\u{1F34A}', 'food:tangerine'],
    ['\u{1F34B}', 'food:lemon'],
    ['\u{1F34C}', 'food:banana'],
    ['\u{1F34D}', 'food:pineapple'],
    ['\u{1F96D}', 'food:mango'],
    ['\u{1F34E}', 'food:red_apple'],
    ['\u{1F34F}', 'food:green_apple'],
    ['\u{1F350}', 'food:pear'],
    ['\u{1F351}', 'food:peach'],
    ['\u{1F352}', 'food:cherries'],
    ['\u{1F353}', 'food:strawberry'],
    ['\u{1FAD0}', 'food:blueberries'],
    ['\u{1F95D}', 'food:kiwi'],
    ['\u{1F345}', 'food:tomato'],
    ['\u{1F951}', 'food:avocado'],
    ['\u{1F346}', 'food:eggplant'],
    ['\u{1F954}', 'food:potato'],
    ['\u{1F955}', 'food:carrot'],
    ['\u{1F33D}', 'food:corn'],
    ['\u{1F336}\u{FE0F}', 'food:hot_pepper'],
    ['\u{1F9C4}', 'food:garlic'],
    ['\u{1F9C5}', 'food:onion'],
    ['\u{1F95C}', 'food:peanuts'],
    ['\u{1F354}', 'food:hamburger'],
    ['\u{1F355}', 'food:pizza'],
    ['\u{1F356}', 'food:meat_on_bone'],
    ['\u{1F357}', 'food:poultry_leg'],
    ['\u{1F969}', 'food:cut_of_meat'],
    ['\u{1F358}', 'food:rice_cracker'],
    ['\u{1F359}', 'food:rice_ball'],
    ['\u{1F35A}', 'food:cooked_rice'],
    ['\u{1F35B}', 'food:curry_rice'],
    ['\u{1F35C}', 'food:steaming_bowl'],
    ['\u{1F35D}', 'food:spaghetti'],
    ['\u{1F35E}', 'food:bread'],
    ['\u{1F35F}', 'food:french_fries'],
    ['\u{1F360}', 'food:roasted_sweet_potato'],
    ['\u{1F361}', 'food:dango'],
    ['\u{1F362}', 'food:oden'],
    ['\u{1F363}', 'food:sushi'],
    ['\u{1F364}', 'food:fried_shrimp'],
    ['\u{1F365}', 'food:fish_cake'],
    ['\u{1F366}', 'food:soft_ice_cream'],
    ['\u{1F367}', 'food:shaved_ice'],
    ['\u{1F368}', 'food:ice_cream'],
    ['\u{1F369}', 'food:doughnut'],
    ['\u{1F36A}', 'food:cookie'],
    ['\u{1F36B}', 'food:chocolate_bar'],
    ['\u{1F36C}', 'food:candy'],
    ['\u{1F36D}', 'food:lollipop'],
    ['\u{1F36E}', 'food:custard'],
    ['\u{1F36F}', 'food:honey_pot'],
    ['\u{1F370}', 'food:shortcake'],
    ['\u{1F371}', 'food:bento_box'],
    ['\u{1F372}', 'food:pot_of_food'],
    ['\u{1F373}', 'food:cooking'],
    ['\u{1F374}', 'food:fork_and_knife'],
    ['\u{1F375}', 'food:teacup_without_handle'],
    ['\u{1F376}', 'food:sake'],
    ['\u{1F377}', 'food:wine_glass'],
    ['\u{1F378}', 'food:cocktail_glass'],
    ['\u{1F379}', 'food:tropical_drink'],
    ['\u{1F37A}', 'food:beer_mug'],
    ['\u{1F37B}', 'food:clinking_beer_mugs'],
    ['\u{1F37C}', 'food:baby_bottle'],
    ['\u{1F950}', 'food:croissant'],
    ['\u{1F956}', 'food:baguette_bread'],
    ['\u{1F957}', 'food:green_salad'],
    ['\u{1F958}', 'food:shallow_pan_of_food'],
    ['\u{1F959}', 'food:stuffed_flatbread'],
    ['\u{1F95A}', 'food:egg'],
    ['\u{1F95E}', 'food:pancakes'],
    ['\u{1F9C0}', 'food:cheese_sector'],
    ['\u{1F9C1}', 'food:cupcake'],
    ['\u{1F9C2}', 'food:salt'],
    ['\u{1F96F}', 'food:bagel'],
    ['\u{1F9C9}', 'food:mate_drink'],
    ['\u{1F9CA}', 'food:ice_cube'],
    ['\u{1F960}', 'food:fortune_cookie'],
    ['\u{1F961}', 'food:takeout_box'],
    ['\u{1F95F}', 'food:dumpling'],
    ['\u{1F9C7}', 'food:waffle'],
    ['\u{1F9C6}', 'food:falafel'],
    ['\u{1F9C8}', 'food:butter'],
    ['\u{1F32D}', 'food:hot_dog'],
    ['\u{1F32E}', 'food:taco'],
    ['\u{1F32F}', 'food:burrito'],
    ['\u{1F9C3}', 'food:beverage_box'],
    ['\u{1F96E}', 'food:moon_cake'],
    ['\u{1F95B}', 'food:glass_of_milk'],
    ['\u{2615}', 'food:hot_beverage'],
    ['\u{1F964}', 'food:cup_with_straw'],
    ['\u{1F9CB}', 'food:bubble_tea'],
    ['\u{1F9CC}', 'food:pot_sticker'],
    ['\u{1F37D}\u{FE0F}', 'food:plate_with_knife_and_fork'],
    ['\u{1F37E}', 'food:bottle_with_popping_cork'],
    ['\u{1F37F}', 'food:popcorn'],
    ['\u{1F962}', 'food:chopsticks'],
    ['\u{1F963}', 'food:bowl_with_spoon'],
    ['\u{1F965}', 'food:coconut'],
    ['\u{1FAD6}', 'food:teapot'],
    ['\u{1FAD7}', 'food:pouring_liquid'],
    ['\u{1F966}', 'food:broccoli'],
    ['\u{1F967}', 'food:pie'],
    ['\u{1F968}', 'food:pretzel'],
    ['\u{1F96A}', 'food:sandwich'],
    ['\u{1F96B}', 'food:canned_food'],
    ['\u{1F96C}', 'food:leafy_green'],
    ['\u{1F34B}\u{200D}\u{1F7E9}', 'food:lime'],
    ['\u{1FAD2}', 'food:olive'],
    ['\u{1FAD1}', 'food:bell_pepper'],
    ['\u{1FAD8}', 'food:beans'],
    ['\u{1F330}', 'food:chestnut'],
    ['\u{1FADB}', 'food:pea_pod'],
    ['\u{1F344}\u{200D}\u{1F7EB}', 'food:brown_mushroom'],
    ['\u{1FADC}', 'food:root_vegetable'],
    ['\u{1FAD3}', 'food:flatbread'],
    ['\u{1F953}', 'food:bacon'],
    ['\u{1FAD4}', 'food:tamale'],
    ['\u{1FAD5}', 'food:fondue'],
    ['\u{1F942}', 'food:clinking_glasses'],
    ['\u{1F943}', 'food:tumbler_glass'],
    ['\u{1F944}', 'food:spoon'],
    ['\u{1FAD9}', 'food:jar'],
    ['\u{1F301}', 'travel:japan/fuji'],
    ['\u{1F303}', 'travel:night_stars'],
    ['\u{1F304}', 'travel:sunrise_mountain'],
    ['\u{1F305}', 'travel:sunrise'],
    ['\u{1F306}', 'travel:city_sunset'],
    ['\u{1F307}', 'travel:sunset'],
    ['\u{1F309}', 'travel:bridge'],
    ['\u{1F30B}', 'travel:volcano'],
    ['\u{1F310}', 'travel:globe'],
    ['\u{1F3E0}', 'travel:house'],
    ['\u{1F3E1}', 'travel:house_with_garden'],
    ['\u{1F3E2}', 'travel:office_building'],
    ['\u{1F3E3}', 'travel:post_office'],
    ['\u{1F3E4}', 'travel:european_post_office'],
    ['\u{1F3E5}', 'travel:hospital'],
    ['\u{1F3E6}', 'travel:bank'],
    ['\u{1F3E7}', 'travel:atm'],
    ['\u{1F3E8}', 'travel:hotel'],
    ['\u{1F3E9}', 'travel:love_hotel'],
    ['\u{1F3EA}', 'travel:convenience_store'],
    ['\u{1F3EB}', 'travel:school'],
    ['\u{1F3EC}', 'travel:department_store'],
    ['\u{1F3ED}', 'travel:factory'],
    ['\u{1F3EE}', 'travel:japan/lantern'],
    ['\u{1F3EF}', 'travel:japan/castle'],
    ['\u{1F3F0}', 'travel:castle'],
    ['\u{26EA}', 'travel:church'],
    ['\u{26F2}', 'travel:fountain'],
    ['\u{26F5}', 'travel:sailboat'],
    ['\u{26FA}', 'travel:tent'],
    ['\u{26FD}', 'travel:fuel_pump'],
    ['\u{1F5FC}', 'travel:japan/tokyo_tower'],
    ['\u{1F5FD}', 'travel:statue_of_liberty'],
    ['\u{1F5FE}', 'travel:japan/map'],
    ['\u{1F5FF}', 'travel:japan/moyai'],
    ['\u{1F3A1}', 'travel:ferris_wheel'],
    ['\u{1F3A2}', 'travel:roller_coaster'],
    ['\u{1F3A0}', 'travel:carousel'],
    ['\u{1F3AF}', 'travel:bullseye'],
    ['\u{1F3D4}\u{FE0F}', 'travel:snow_mountain'],
    ['\u{1F3D5}\u{FE0F}', 'travel:camping'],
    ['\u{1F3D6}\u{FE0F}', 'travel:beach'],
    ['\u{1F3D7}\u{FE0F}', 'travel:construction'],
    ['\u{1F3D8}\u{FE0F}', 'travel:houses'],
    ['\u{1F3D9}\u{FE0F}', 'travel:cityscape'],
    ['\u{1F3DA}\u{FE0F}', 'travel:old_house'],
    ['\u{1F3DB}\u{FE0F}', 'travel:temple'],
    ['\u{1F3DC}\u{FE0F}', 'travel:desert'],
    ['\u{1F3DD}\u{FE0F}', 'travel:island'],
    ['\u{1F3DE}\u{FE0F}', 'travel:park'],
    ['\u{1F3DF}\u{FE0F}', 'travel:stadium'],
    ['\u{1F680}', 'travel:vehicle/rocket'],
    ['\u{1F681}', 'travel:vehicle/helicopter'],
    ['\u{1F682}', 'travel:vehicle/steam_train'],
    ['\u{1F683}', 'travel:vehicle/train_car'],
    ['\u{1F684}', 'travel:vehicle/bullet_train_300'],
    ['\u{1F685}', 'travel:vehicle/bullet_train'],
    ['\u{1F686}', 'travel:vehicle/train'],
    ['\u{1F687}', 'travel:vehicle/subway'],
    ['\u{1F688}', 'travel:vehicle/light_rail'],
    ['\u{1F689}', 'travel:vehicle/station'],
    ['\u{1F68A}', 'travel:vehicle/tram'],
    ['\u{1F68B}', 'travel:vehicle/tram_car'],
    ['\u{1F68C}', 'travel:vehicle/bus'],
    ['\u{1F68D}', 'travel:vehicle/oncoming_bus'],
    ['\u{1F68E}', 'travel:vehicle/trolleybus'],
    ['\u{1F68F}', 'travel:vehicle/bus_stop'],
    ['\u{1F690}', 'travel:vehicle/minibus'],
    ['\u{1F691}', 'travel:vehicle/ambulance'],
    ['\u{1F692}', 'travel:vehicle/fire_engine'],
    ['\u{1F693}', 'travel:vehicle/police_car'],
    ['\u{1F694}', 'travel:vehicle/oncoming_police_car'],
    ['\u{1F695}', 'travel:vehicle/taxi'],
    ['\u{1F696}', 'travel:vehicle/oncoming_taxi'],
    ['\u{1F697}', 'travel:vehicle/car'],
    ['\u{1F698}', 'travel:vehicle/oncoming_car'],
    ['\u{1F699}', 'travel:vehicle/rv'],
    ['\u{1F69A}', 'travel:vehicle/truck'],
    ['\u{1F69B}', 'travel:vehicle/semi'],
    ['\u{1F69C}', 'travel:vehicle/tractor'],
    ['\u{1F69D}', 'travel:vehicle/monorail'],
    ['\u{1F69E}', 'travel:vehicle/mountain_train'],
    ['\u{1F69F}', 'travel:vehicle/suspension_railway'],
    ['\u{1F6A0}', 'travel:vehicle/cableway'],
    ['\u{1F6A1}', 'travel:vehicle/aerial_tram'],
    ['\u{1F6A2}', 'travel:vehicle/ship'],
    ['\u{1F6A4}', 'travel:vehicle/speedboat'],
    ['\u{1F6F0}\u{FE0F}', 'travel:vehicle/satellite'],
    ['\u{1F6F3}\u{FE0F}', 'travel:vehicle/cruise_ship'],
    ['\u{1F6F4}', 'travel:vehicle/scooter'],
    ['\u{1F6F5}', 'travel:vehicle/motor_scooter'],
    ['\u{1F6F6}', 'travel:vehicle/canoe'],
    ['\u{1F6F7}', 'travel:vehicle/sled'],
    ['\u{1F6F8}', 'travel:vehicle/ufo'],
    ['\u{1F6F9}', 'travel:vehicle/skateboard'],
    ['\u{1F6FA}', 'travel:vehicle/rickshaw'],
    ['\u{1F6FB}', 'travel:vehicle/cable_car'],
    ['\u{1F6FC}', 'travel:vehicle/tramway'],
    ['\u{2708}\u{FE0F}', 'travel:vehicle/plane'],
    ['\u{1F6A5}', 'travel:traffic_light_h'],
    ['\u{1F6A6}', 'travel:traffic_light_v'],
    ['\u{1F6A7}', 'travel:roadblock'],
    ['\u{1F6A8}', 'travel:siren'],
    ['\u{1F6A9}', 'travel:flag'],
    ['\u{1F6AA}', 'travel:door'],
    ['\u{1F6AB}', 'travel:no_entry'],
    ['\u{1F6AC}', 'travel:smoking'],
    ['\u{1F6AD}', 'travel:no_smoking'],
    ['\u{1F6AE}', 'travel:trash_bin'],
    ['\u{1F6AF}', 'travel:no_littering'],
    ['\u{1F6B0}', 'travel:water_fountain'],
    ['\u{1F6B1}', 'travel:non_potable_water'],
    ['\u{1F6B2}', 'travel:vehicle/bike'],
    ['\u{1F6B3}', 'travel:no_bikes'],
    ['\u{1F6B4}', 'travel:cyclist'],
    ['\u{1F6B5}', 'travel:mountain_cyclist'],
    ['\u{1F6B6}', 'travel:pedestrian'],
    ['\u{1F6B7}', 'travel:no_pedestrians'],
    ['\u{1F6B8}', 'travel:crossing'],
    ['\u{1F6B9}', 'travel:men_room'],
    ['\u{1F6BA}', 'travel:women_room'],
    ['\u{1F6BB}', 'travel:restroom'],
    ['\u{1F6BC}', 'travel:baby_symbol'],
    ['\u{1F6BD}', 'travel:toilet'],
    ['\u{1F6BE}', 'travel:wc'],
    ['\u{1F6BF}', 'travel:shower'],
    ['\u{1F6C0}', 'travel:bath'],
    ['\u{1F6C1}', 'travel:bathtub'],
    ['\u{1F6C2}', 'travel:passport_control'],
    ['\u{1F6C3}', 'travel:customs'],
    ['\u{1F6C4}', 'travel:baggage_claim'],
    ['\u{1F6C5}', 'travel:left_luggage'],
    ['\u{1F6CB}\u{FE0F}', 'travel:couch_lamp'],
    ['\u{1F6CC}', 'travel:sleeping'],
    ['\u{1F6CD}\u{FE0F}', 'travel:shopping_bags'],
    ['\u{1F6CE}\u{FE0F}', 'travel:bellhop'],
    ['\u{1F6CF}\u{FE0F}', 'travel:bed'],
    ['\u{1F6D0}', 'travel:worship'],
    ['\u{1F6D1}', 'travel:stop_sign'],
    ['\u{1F6D2}', 'travel:cart'],
    ['\u{1F6D5}', 'travel:temple_hindu'],
    ['\u{1F6D6}', 'travel:hut'],
    ['\u{1F6D7}', 'travel:elevator'],
    ['\u{1F6DD}', 'travel:slide'],
    ['\u{1F6DE}', 'travel:wheel'],
    ['\u{1F6DF}', 'travel:buoy'],
    ['\u{1F30D}', 'travel:globe_showing_europe_africa'],
    ['\u{1F30E}', 'travel:globe_showing_americas'],
    ['\u{1F30F}', 'travel:globe_showing_asia_australia'],
    ['\u{1F5FA}\u{FE0F}', 'travel:world_map'],
    ['\u{1F9ED}', 'travel:compass'],
    ['\u{26F0}\u{FE0F}', 'travel:mountain'],
    ['\u{1F492}', 'travel:wedding'],
    ['\u{1F54C}', 'travel:mosque'],
    ['\u{1F54D}', 'travel:synagogue'],
    ['\u{1F54B}', 'travel:kaaba'],
    ['\u{2668}\u{FE0F}', 'travel:hot_springs'],
    ['\u{1F488}', 'travel:barber_pole'],
    ['\u{1F9BD}', 'travel:manual_wheelchair'],
    ['\u{1F9BC}', 'travel:motorized_wheelchair'],
    ['\u{2693}', 'travel:anchor'],
    ['\u{26F4}\u{FE0F}', 'travel:ferry'],
    ['\u{1F6EB}', 'travel:airplane_departure'],
    ['\u{1F6EC}', 'travel:airplane_arrival'],
    ['\u{231B}', 'travel:hourglass_done'],
    ['\u{23F3}', 'travel:hourglass_not_done'],
    ['\u{231A}', 'travel:watch'],
    ['\u{23F0}', 'travel:alarm_clock'],
    ['\u{23F1}\u{FE0F}', 'travel:stopwatch'],
    ['\u{23F2}\u{FE0F}', 'travel:timer_clock'],
    ['\u{1F321}\u{FE0F}', 'travel:thermometer'],
    ['\u{2602}\u{FE0F}', 'travel:umbrella'],
    ['\u{26F1}\u{FE0F}', 'travel:umbrella_on_ground'],
    ['\u{1F380}', 'activities:balloon_ribbon'],
    ['\u{1F381}', 'activities:gift'],
    ['\u{1F382}', 'activities:cake'],
    ['\u{1F383}', 'activities:jack_o_lantern'],
    ['\u{1F384}', 'activities:christmas_tree'],
    ['\u{1F385}', 'activities:santa'],
    ['\u{1F386}', 'activities:fireworks'],
    ['\u{1F387}', 'activities:sparkler'],
    ['\u{1F388}', 'activities:balloon'],
    ['\u{1F389}', 'activities:popper'],
    ['\u{1F38A}', 'activities:confetti'],
    ['\u{1F38B}', 'activities:tanabata'],
    ['\u{1F38C}', 'activities:japan/flag'],
    ['\u{1F38D}', 'activities:japan/kadomatsu'],
    ['\u{1F38E}', 'activities:japan/dolls'],
    ['\u{1F38F}', 'activities:japan/carp'],
    ['\u{1F390}', 'activities:wind_chime'],
    ['\u{1F391}', 'activities:japan/moon_viewing'],
    ['\u{1F392}', 'activities:backpack'],
    ['\u{1F393}', 'activities:graduation'],
    ['\u{1F3A3}', 'activities:fishing'],
    ['\u{1F3A4}', 'activities:microphone'],
    ['\u{1F3A5}', 'activities:movie_camera'],
    ['\u{1F3A6}', 'activities:cinema'],
    ['\u{1F3A7}', 'activities:headphones'],
    ['\u{1F3A8}', 'activities:palette'],
    ['\u{1F3A9}', 'activities:top_hat'],
    ['\u{1F3AA}', 'activities:circus'],
    ['\u{1F3AB}', 'activities:ticket'],
    ['\u{1F3AC}', 'activities:clapper'],
    ['\u{1F3AD}', 'activities:drama'],
    ['\u{1F3AE}', 'activities:controller'],
    ['\u{1F3B0}', 'activities:slot'],
    ['\u{1F3B1}', 'activities:billiards'],
    ['\u{1F3B2}', 'activities:die'],
    ['\u{1F3B3}', 'activities:bowling'],
    ['\u{1F3B4}', 'activities:flower_playing_cards'],
    ['\u{1F3B5}', 'activities:music_note'],
    ['\u{1F3B6}', 'activities:music_notes'],
    ['\u{1F3B7}', 'activities:sax'],
    ['\u{1F3B8}', 'activities:guitar'],
    ['\u{1F3B9}', 'activities:piano'],
    ['\u{1F3BA}', 'activities:trumpet'],
    ['\u{1F3BB}', 'activities:violin'],
    ['\u{1F3BC}', 'activities:score'],
    ['\u{1F3BD}', 'activities:running_shirt'],
    ['\u{1F3BE}', 'activities:tennis'],
    ['\u{1F3BF}', 'activities:skiing'],
    ['\u{1F3C0}', 'activities:basketball'],
    ['\u{1F3C1}', 'activities:checkered_flag'],
    ['\u{1F3C2}', 'activities:snowboarder'],
    ['\u{1F3C3}', 'activities:runner'],
    ['\u{1F3C4}', 'activities:surfer'],
    ['\u{1F3C5}', 'activities:medal_sports'],
    ['\u{1F3C6}', 'activities:trophy'],
    ['\u{1F3C7}', 'activities:horse_racing'],
    ['\u{1F3C8}', 'activities:football'],
    ['\u{1F3C9}', 'activities:rugby'],
    ['\u{1F3CA}', 'activities:swimmer'],
    ['\u{1F3CB}\u{FE0F}', 'activities:weightlifter'],
    ['\u{1F3CC}\u{FE0F}', 'activities:golfer'],
    ['\u{1F3CD}\u{FE0F}', 'activities:motorcycle'],
    ['\u{1F3CE}\u{FE0F}', 'activities:race_car'],
    ['\u{1F3CF}', 'activities:cricket'],
    ['\u{1F3D0}', 'activities:volleyball'],
    ['\u{1F3D1}', 'activities:field_hockey'],
    ['\u{1F3D2}', 'activities:ice_hockey'],
    ['\u{1F3D3}', 'activities:ping_pong'],
    ['\u{1F3F8}', 'activities:badminton'],
    ['\u{1F94A}', 'activities:boxing'],
    ['\u{1F3F9}', 'activities:archery'],
    ['\u{1F3FA}', 'activities:amphora'],
    ['\u{1F4F1}', 'activities:mobile'],
    ['\u{1F4F2}', 'activities:mobile_arrow'],
    ['\u{1F4F3}', 'activities:vibration'],
    ['\u{1F4F4}', 'activities:mobile_off'],
    ['\u{1F4F5}', 'activities:no_phones'],
    ['\u{1F4F6}', 'activities:signal'],
    ['\u{1F4F7}', 'activities:camera'],
    ['\u{1F4F8}', 'activities:camera_flash'],
    ['\u{1F4F9}', 'activities:video_camera'],
    ['\u{1F4FA}', 'activities:tv'],
    ['\u{1F4FB}', 'activities:radio'],
    ['\u{1F4FC}', 'activities:videocassette'],
    ['\u{1F4FD}\u{FE0F}', 'activities:projector'],
    ['\u{1F576}\u{FE0F}', 'activities:sunglasses'],
    ['\u{1F579}\u{FE0F}', 'activities:joystick'],
    ['\u{1F941}', 'activities:drum'],
    ['\u{1F945}', 'activities:goal_net'],
    ['\u{1F947}', 'activities:medal/1st'],
    ['\u{1F948}', 'activities:medal/2nd'],
    ['\u{1F949}', 'activities:medal/3rd'],
    ['\u{1F94B}', 'activities:martial_uniform'],
    ['\u{1F94C}', 'activities:curling'],
    ['\u{1F94D}', 'activities:lacrosse'],
    ['\u{1F94F}', 'activities:flying_disc'],
    ['\u{1F952}', 'activities:softball'],
    ['\u{1F94E}', 'activities:softball'],
    ['\u{1F9E9}', 'activities:jigsaw'],
    ['\u{1F9FF}', 'activities:amulet'],
    ['\u{26F3}', 'activities:golf'],
    ['\u{26F7}', 'activities:skier'],
    ['\u{26F7}\u{FE0F}', 'activities:skier'],
    ['\u{26F8}', 'activities:ice_skate'],
    ['\u{26F8}\u{FE0F}', 'activities:ice_skate'],
    ['\u{26F9}', 'activities:bounce_ball'],
    ['\u{26F9}\u{FE0F}', 'activities:bounce_ball'],
    ['\u{26FF}', 'activities:slingshot'],
    ['\u{2747}\u{FE0F}', 'activities:sparkle'],
    ['\u{2796}', 'activities:minus'],
    ['\u{2797}', 'activities:divide'],
    ['\u{27B0}', 'activities:loop'],
    ['\u{27BF}', 'activities:loop_double'],
    ['\u{2B1B}', 'activities:black_square'],
    ['\u{2B1C}', 'activities:white_square'],
    ['\u{1F9E8}', 'activities:firecracker'],
    ['\u{1F9E7}', 'activities:red_envelope'],
    ['\u{1F397}\u{FE0F}', 'activities:reminder_ribbon'],
    ['\u{1F39F}\u{FE0F}', 'activities:admission_tickets'],
    ['\u{1F396}\u{FE0F}', 'activities:military_medal'],
    ['\u{1F93F}', 'activities:diving_mask'],
    ['\u{1FAA9}', 'activities:mirror_ball'],
    ['\u{2660}\u{FE0F}', 'activities:spade_suit'],
    ['\u{2666}\u{FE0F}', 'activities:diamond_suit'],
    ['\u{2663}\u{FE0F}', 'activities:club_suit'],
    ['\u{265F}\u{FE0F}', 'activities:chess_pawn'],
    ['\u{1F0CF}', 'activities:joker'],
    ['\u{1F004}', 'activities:mahjong_red_dragon'],
    ['\u{1F5BC}\u{FE0F}', 'activities:framed_picture'],
    ['\u{1F48D}', 'objects:ring'],
    ['\u{1F48E}', 'objects:gem'],
    ['\u{1F4B0}', 'objects:money_bag'],
    ['\u{1F4B1}', 'objects:currency_exchange'],
    ['\u{1F4B2}', 'objects:dollar'],
    ['\u{1F4B3}', 'objects:credit_card'],
    ['\u{1F4B4}', 'objects:yen'],
    ['\u{1F4B5}', 'objects:dollar_bill'],
    ['\u{1F4B6}', 'objects:euro_bill'],
    ['\u{1F4B7}', 'objects:pound_bill'],
    ['\u{1F4B8}', 'objects:money_wings'],
    ['\u{1F4B9}', 'objects:chart_up'],
    ['\u{1F4BA}', 'objects:seat'],
    ['\u{1F4BB}', 'objects:computer'],
    ['\u{1F4BC}', 'objects:briefcase'],
    ['\u{1F4BD}', 'objects:minidisc'],
    ['\u{1F4BE}', 'objects:floppy'],
    ['\u{1F4BF}', 'objects:cd'],
    ['\u{1F4C0}', 'objects:dvd'],
    ['\u{1F4C1}', 'objects:folder_open'],
    ['\u{1F4C2}', 'objects:folder'],
    ['\u{1F4C3}', 'objects:page_curl'],
    ['\u{1F4C4}', 'objects:document'],
    ['\u{1F4C5}', 'objects:calendar'],
    ['\u{1F4C6}', 'objects:tear_calendar'],
    ['\u{1F4C7}', 'objects:card_index'],
    ['\u{1F4C8}', 'objects:chart_increasing'],
    ['\u{1F4C9}', 'objects:chart_decreasing'],
    ['\u{1F4CA}', 'objects:bar_chart'],
    ['\u{1F4CB}', 'objects:clipboard'],
    ['\u{1F4CC}', 'objects:pushpin'],
    ['\u{1F4CD}', 'objects:pin'],
    ['\u{1F4CE}', 'objects:paperclip'],
    ['\u{1F4CF}', 'objects:ruler'],
    ['\u{1F4D0}', 'objects:triangle_ruler'],
    ['\u{1F4D1}', 'objects:bookmarks'],
    ['\u{1F4D2}', 'objects:ledger'],
    ['\u{1F4D3}', 'objects:notebook'],
    ['\u{1F4D4}', 'objects:notebook_decor'],
    ['\u{1F4D5}', 'objects:book_closed'],
    ['\u{1F4D6}', 'objects:book_open'],
    ['\u{1F4D7}', 'objects:book_green'],
    ['\u{1F4D8}', 'objects:book_blue'],
    ['\u{1F4D9}', 'objects:book_orange'],
    ['\u{1F4DA}', 'objects:books'],
    ['\u{1F4DB}', 'objects:name_badge'],
    ['\u{1F4DC}', 'objects:scroll'],
    ['\u{1F4DD}', 'objects:memo'],
    ['\u{1F4DE}', 'objects:phone_receiver'],
    ['\u{1F4DF}', 'objects:pager'],
    ['\u{1F4E0}', 'objects:fax'],
    ['\u{1F4E1}', 'objects:satellite_dish'],
    ['\u{1F4E2}', 'objects:megaphone'],
    ['\u{1F4E3}', 'objects:bullhorn'],
    ['\u{1F4E4}', 'objects:outbox'],
    ['\u{1F4E5}', 'objects:inbox'],
    ['\u{1F4E6}', 'objects:package'],
    ['\u{1F4E7}', 'objects:email'],
    ['\u{1F4E8}', 'objects:envelope_in'],
    ['\u{1F4E9}', 'objects:envelope_sent'],
    ['\u{1F4EA}', 'objects:mailbox_closed'],
    ['\u{1F4EB}', 'objects:mailbox_open'],
    ['\u{1F4EC}', 'objects:mailbox_unread'],
    ['\u{1F4ED}', 'objects:mailbox_unread_closed'],
    ['\u{1F4EE}', 'objects:postbox'],
    ['\u{1F4EF}', 'objects:horn'],
    ['\u{1F4F0}', 'objects:newspaper'],
    ['\u{1F500}', 'objects:shuffle'],
    ['\u{1F501}', 'objects:repeat'],
    ['\u{1F502}', 'objects:repeat_one'],
    ['\u{1F503}', 'objects:reload'],
    ['\u{1F504}', 'objects:refresh'],
    ['\u{1F505}', 'objects:dim'],
    ['\u{1F506}', 'objects:bright'],
    ['\u{1F507}', 'objects:mute'],
    ['\u{1F508}', 'objects:volume_low'],
    ['\u{1F509}', 'objects:volume_mid'],
    ['\u{1F50A}', 'objects:volume_high'],
    ['\u{1F50B}', 'objects:battery'],
    ['\u{1F50C}', 'objects:plug'],
    ['\u{1F50D}', 'objects:search'],
    ['\u{1F50E}', 'objects:search_right'],
    ['\u{1F50F}', 'objects:lock_pen'],
    ['\u{1F510}', 'objects:lock_key'],
    ['\u{1F511}', 'objects:key'],
    ['\u{1F512}', 'objects:lock'],
    ['\u{1F513}', 'objects:unlock'],
    ['\u{1F514}', 'objects:bell'],
    ['\u{1F515}', 'objects:bell_slash'],
    ['\u{1F516}', 'objects:bookmark'],
    ['\u{1F517}', 'objects:link'],
    ['\u{1F518}', 'objects:radio_button'],
    ['\u{1F519}', 'objects:back'],
    ['\u{1F51A}', 'objects:end'],
    ['\u{1F51B}', 'objects:on'],
    ['\u{1F51C}', 'objects:soon'],
    ['\u{1F51D}', 'objects:top'],
    ['\u{1F526}', 'objects:flashlight'],
    ['\u{1F527}', 'objects:wrench'],
    ['\u{1F528}', 'objects:hammer'],
    ['\u{1F529}', 'objects:nut_bolt'],
    ['\u{1F52A}', 'objects:knife'],
    ['\u{1F52B}', 'objects:gun'],
    ['\u{1F52C}', 'objects:microscope'],
    ['\u{1F52D}', 'objects:telescope'],
    ['\u{1F52E}', 'objects:crystal_ball'],
    ['\u{1F550}', 'objects:clock/1'],
    ['\u{1F551}', 'objects:clock/2'],
    ['\u{1F552}', 'objects:clock/3'],
    ['\u{1F553}', 'objects:clock/4'],
    ['\u{1F554}', 'objects:clock/5'],
    ['\u{1F555}', 'objects:clock/6'],
    ['\u{1F556}', 'objects:clock/7'],
    ['\u{1F557}', 'objects:clock/8'],
    ['\u{1F558}', 'objects:clock/9'],
    ['\u{1F559}', 'objects:clock/10'],
    ['\u{1F55A}', 'objects:clock/11'],
    ['\u{1F55B}', 'objects:clock/12'],
    ['\u{1F55C}', 'objects:clock/1_30'],
    ['\u{1F55D}', 'objects:clock/2_30'],
    ['\u{1F55E}', 'objects:clock/3_30'],
    ['\u{1F55F}', 'objects:clock/4_30'],
    ['\u{1F560}', 'objects:clock/5_30'],
    ['\u{1F561}', 'objects:clock/6_30'],
    ['\u{1F562}', 'objects:clock/7_30'],
    ['\u{1F563}', 'objects:clock/8_30'],
    ['\u{1F564}', 'objects:clock/9_30'],
    ['\u{1F565}', 'objects:clock/10_30'],
    ['\u{1F566}', 'objects:clock/11_30'],
    ['\u{1F567}', 'objects:clock/12_30'],
    ['\u{1F56F}\u{FE0F}', 'objects:candle'],
    ['\u{1F570}\u{FE0F}', 'objects:clock/mantel'],
    ['\u{1F573}\u{FE0F}', 'objects:hole'],
    ['\u{1F574}\u{FE0F}', 'objects:levitate'],
    ['\u{1F58A}\u{FE0F}', 'objects:pen'],
    ['\u{1F58B}\u{FE0F}', 'objects:fountain_pen'],
    ['\u{1F58C}\u{FE0F}', 'objects:paintbrush'],
    ['\u{1F58D}\u{FE0F}', 'objects:crayon'],
    ['\u{1F5C2}\u{FE0F}', 'objects:card_file'],
    ['\u{1F5C3}\u{FE0F}', 'objects:card_drawers'],
    ['\u{1F5C4}\u{FE0F}', 'objects:cabinet'],
    ['\u{1F5D1}', 'objects:trash_can'],
    ['\u{1F5D2}\u{FE0F}', 'objects:notepad_spiral'],
    ['\u{1F5D3}\u{FE0F}', 'objects:calendar_spiral'],
    ['\u{1F5DC}\u{FE0F}', 'objects:clamp'],
    ['\u{1F5DD}\u{FE0F}', 'objects:old_key'],
    ['\u{1F5DE}\u{FE0F}', 'objects:rolled_newspaper'],
    ['\u{1F5E1}\u{FE0F}', 'objects:dagger'],
    ['\u{1F5F3}\u{FE0F}', 'objects:ballot_box'],
    ['\u{1F6E0}\u{FE0F}', 'objects:hammer_wrench'],
    ['\u{1F6E1}\u{FE0F}', 'objects:shield'],
    ['\u{1F6E2}\u{FE0F}', 'objects:oil_drum'],
    ['\u{1F6E3}\u{FE0F}', 'objects:highway'],
    ['\u{1F6E4}\u{FE0F}', 'objects:tracks'],
    ['\u{1F6E5}\u{FE0F}', 'objects:boat'],
    ['\u{1F6E9}\u{FE0F}', 'objects:propeller_plane'],
    ['\u{1F9EF}', 'objects:extinguisher'],
    ['\u{1F9F0}', 'objects:toolbox'],
    ['\u{1F9F1}', 'objects:brick'],
    ['\u{1F9F2}', 'objects:magnet'],
    ['\u{1F9F3}', 'objects:luggage'],
    ['\u{1F9F4}', 'objects:lotion'],
    ['\u{1F9F5}', 'objects:thread'],
    ['\u{1F9F6}', 'objects:yarn'],
    ['\u{1F9F7}', 'objects:safety_pin'],
    ['\u{1F9F8}', 'objects:teddy'],
    ['\u{1F9F9}', 'objects:broom'],
    ['\u{1FA80}', 'objects:yoyo'],
    ['\u{1FA81}', 'objects:kite'],
    ['\u{1FA82}', 'objects:parachute'],
    ['\u{1FA83}', 'objects:boomerang'],
    ['\u{1FA84}', 'objects:magic_wand'],
    ['\u{1FA85}', 'objects:pinata'],
    ['\u{1FA86}', 'objects:nesting_dolls'],
    ['\u{1FA90}', 'objects:ringed_planet'],
    ['\u{1FA91}', 'objects:chair'],
    ['\u{1FA92}', 'objects:razor'],
    ['\u{1FA93}', 'objects:axe'],
    ['\u{1FA94}', 'objects:diaper'],
    ['\u{1FA95}', 'objects:mirror'],
    ['\u{1FA96}', 'objects:window'],
    ['\u{1FA97}', 'objects:plunger'],
    ['\u{1FA98}', 'objects:mouse_trap'],
    ['\u{1FA99}', 'objects:coin'],
    ['\u{1FA9A}', 'objects:toothbrush'],
    ['\u{1FA9B}', 'objects:shower_head'],
    ['\u{1FA9C}', 'objects:bucket'],
    ['\u{1FA9D}', 'objects:hook'],
    ['\u{1FA9F}', 'objects:military_helmet'],
    ['\u{1FAA0}', 'objects:accordion'],
    ['\u{1FAA1}', 'objects:long_drum'],
    ['\u{1FAA2}', 'objects:coin_gold'],
    ['\u{1FAA3}', 'objects:carpentry_saw'],
    ['\u{1FAA4}', 'objects:screwdriver'],
    ['\u{1FAA5}', 'objects:ladder'],
    ['\u{1FAA6}', 'objects:gravestone'],
    ['\u{1FAA7}', 'objects:placard'],
    ['\u{1FAA8}', 'objects:rock'],
    ['\u{1FAAB}', 'objects:hair_slide'],
    ['\u{1FAAC}', 'objects:spectacles'],
    ['\u{1FAAD}', 'objects:magnifying_glass'],
    ['\u{1FAAE}', 'objects:microscope_alternative'],
    ['\u{1FAAF}', 'objects:telescope_alternative'],
    ['\u{1F9FA}', 'objects:basket'],
    ['\u{1F9FB}', 'objects:toilet_paper'],
    ['\u{1F9FC}', 'objects:soap'],
    ['\u{1F9FD}', 'objects:sponge'],
    ['\u{1F9FE}', 'objects:receipt'],
    ['\u{26CF}\u{FE0F}', 'objects:pickaxe'],
    ['\u{26D1}\u{FE0F}', 'objects:helmet_white'],
    ['\u{26D3}\u{FE0F}', 'objects:chains'],
    ['\u{2702}\u{FE0F}', 'objects:scissors'],
    ['\u{2705}', 'objects:check_box'],
    ['\u{2709}\u{FE0F}', 'objects:envelope'],
    ['\u{270F}\u{FE0F}', 'objects:pencil'],
    ['\u{2712}\u{FE0F}', 'objects:nib'],
    ['\u{2714}\u{FE0F}', 'objects:check_mark'],
    ['\u{2716}\u{FE0F}', 'objects:x_mark'],
    ['\u{271D}\u{FE0F}', 'objects:cross'],
    ['\u{2721}\u{FE0F}', 'objects:star_of_david'],
    ['\u{1F453}', 'objects:glasses'],
    ['\u{1F97D}', 'objects:goggles'],
    ['\u{1F97C}', 'objects:lab_coat'],
    ['\u{1F9BA}', 'objects:safety_vest'],
    ['\u{1F454}', 'objects:necktie'],
    ['\u{1F455}', 'objects:t_shirt'],
    ['\u{1F456}', 'objects:jeans'],
    ['\u{1F9E3}', 'objects:scarf'],
    ['\u{1F9E4}', 'objects:gloves'],
    ['\u{1F9E5}', 'objects:coat'],
    ['\u{1F9E6}', 'objects:socks'],
    ['\u{1F457}', 'objects:dress'],
    ['\u{1F458}', 'objects:kimono'],
    ['\u{1F97B}', 'objects:sari'],
    ['\u{1FA71}', 'objects:one_piece_swimsuit'],
    ['\u{1FA72}', 'objects:briefs'],
    ['\u{1FA73}', 'objects:shorts'],
    ['\u{1F459}', 'objects:bikini'],
    ['\u{1F45A}', 'objects:woman_s_clothes'],
    ['\u{1F45B}', 'objects:purse'],
    ['\u{1F45C}', 'objects:handbag'],
    ['\u{1F45D}', 'objects:clutch_bag'],
    ['\u{1FA74}', 'objects:thong_sandal'],
    ['\u{1F45E}', 'objects:man_s_shoe'],
    ['\u{1F45F}', 'objects:running_shoe'],
    ['\u{1F97E}', 'objects:hiking_boot'],
    ['\u{1F97F}', 'objects:flat_shoe'],
    ['\u{1F460}', 'objects:high_heeled_shoe'],
    ['\u{1F461}', 'objects:woman_s_sandal'],
    ['\u{1FA70}', 'objects:ballet_shoes'],
    ['\u{1F462}', 'objects:woman_s_boot'],
    ['\u{1F451}', 'objects:crown'],
    ['\u{1F452}', 'objects:woman_s_hat'],
    ['\u{1F9E2}', 'objects:billed_cap'],
    ['\u{1F4FF}', 'objects:prayer_beads'],
    ['\u{1F484}', 'objects:lipstick'],
    ['\u{1F399}\u{FE0F}', 'objects:studio_microphone'],
    ['\u{1F39A}\u{FE0F}', 'objects:level_slider'],
    ['\u{1F39B}\u{FE0F}', 'objects:control_knobs'],
    ['\u{1FA87}', 'objects:maracas'],
    ['\u{1FA88}', 'objects:flute'],
    ['\u{1FA89}', 'objects:harp'],
    ['\u{260E}\u{FE0F}', 'objects:telephone'],
    ['\u{1F5A5}\u{FE0F}', 'objects:desktop_computer'],
    ['\u{1F5A8}\u{FE0F}', 'objects:printer'],
    ['\u{2328}\u{FE0F}', 'objects:keyboard'],
    ['\u{1F5B1}\u{FE0F}', 'objects:computer_mouse'],
    ['\u{1F5B2}\u{FE0F}', 'objects:trackball'],
    ['\u{1F9EE}', 'objects:abacus'],
    ['\u{1F39E}\u{FE0F}', 'objects:film_frames'],
    ['\u{1F3F7}\u{FE0F}', 'objects:label'],
    ['\u{1F587}\u{FE0F}', 'objects:linked_paperclips'],
    ['\u{2692}\u{FE0F}', 'objects:hammer_and_pick'],
    ['\u{2694}\u{FE0F}', 'objects:crossed_swords'],
    ['\u{2699}\u{FE0F}', 'objects:gear'],
    ['\u{2696}\u{FE0F}', 'objects:balance_scale'],
    ['\u{1F9AF}', 'objects:white_cane'],
    ['\u{26D3}\u{FE0F}\u{200D}\u{1F4A5}', 'objects:broken_chain'],
    ['\u{1FA8F}', 'objects:shovel'],
    ['\u{2697}\u{FE0F}', 'objects:alembic'],
    ['\u{1F9EA}', 'objects:test_tube'],
    ['\u{1F9EB}', 'objects:petri_dish'],
    ['\u{1F9EC}', 'objects:dna'],
    ['\u{1F489}', 'objects:syringe'],
    ['\u{1FA78}', 'objects:drop_of_blood'],
    ['\u{1F48A}', 'objects:pill'],
    ['\u{1FA79}', 'objects:adhesive_bandage'],
    ['\u{1FA7C}', 'objects:crutch'],
    ['\u{1FA7A}', 'objects:stethoscope'],
    ['\u{1FA7B}', 'objects:x_ray'],
    ['\u{1FAE7}', 'objects:bubbles'],
    ['\u{1FAAA}', 'objects:identification_card'],
    ['\u{1F3F4}', 'symbols:black_flag'],
    ['\u{1F3F5}', 'symbols:peace'],
    ['\u{1F530}', 'symbols:japan/beginner'],
    ['\u{1F201}', 'symbols:japan/here'],
    ['\u{1F202}\u{FE0F}', 'symbols:japan/service_charge'],
    ['\u{1F237}\u{FE0F}', 'symbols:japan/monthly_amount'],
    ['\u{1F236}', 'symbols:japan/not_free_of_charge'],
    ['\u{1F22F}', 'symbols:japan/reserved'],
    ['\u{1F250}', 'symbols:japan/bargain'],
    ['\u{1F239}', 'symbols:japan/discount'],
    ['\u{1F21A}', 'symbols:japan/free_of_charge'],
    ['\u{1F232}', 'symbols:japan/prohibited'],
    ['\u{1F251}', 'symbols:japan/acceptable'],
    ['\u{1F238}', 'symbols:japan/application'],
    ['\u{1F234}', 'symbols:japan/passing_grade'],
    ['\u{1F233}', 'symbols:japan/vacancy'],
    ['\u{3297}\u{FE0F}', 'symbols:japan/congratulations'],
    ['\u{3299}\u{FE0F}', 'symbols:japan/secret'],
    ['\u{1F23A}', 'symbols:japan/open_for_business'],
    ['\u{1F235}', 'symbols:japan/no_vacancy'],
    ['\u{1F531}', 'symbols:trident'],
    ['\u{1F532}', 'symbols:square_button_black'],
    ['\u{1F533}', 'symbols:square_button_white'],
    ['\u{1F534}', 'symbols:red_circle'],
    ['\u{1F535}', 'symbols:blue_circle'],
    ['\u{1F536}', 'symbols:orange_diamond'],
    ['\u{1F537}', 'symbols:blue_diamond'],
    ['\u{1F538}', 'symbols:small_orange_diamond'],
    ['\u{1F539}', 'symbols:small_blue_diamond'],
    ['\u{1F53A}', 'symbols:up_triangle'],
    ['\u{1F53B}', 'symbols:down_triangle'],
    ['\u{1F53C}', 'symbols:up_button'],
    ['\u{1F53D}', 'symbols:down_button'],
    ['\u{1F5E8}\u{FE0F}', 'symbols:left_speech'],
    ['\u{26A0}\u{FE0F}', 'symbols:warning'],
    ['\u{26AA}', 'symbols:white_circle'],
    ['\u{26AB}', 'symbols:black_circle'],
    ['\u{26B0}\u{FE0F}', 'symbols:coffin'],
    ['\u{26B1}\u{FE0F}', 'symbols:urn'],
    ['\u{26BD}', 'symbols:soccer'],
    ['\u{26BE}', 'symbols:baseball'],
    ['\u{26CE}', 'symbols:ophiuchus'],
    ['\u{26D4}', 'symbols:no_entry_red'],
    ['\u{26E9}\u{FE0F}', 'symbols:shinto_shrine'],
    ['\u{2733}\u{FE0F}', 'symbols:asterisk'],
    ['\u{2734}\u{FE0F}', 'symbols:eight_pointed_star'],
    ['\u{274C}', 'symbols:cross_mark'],
    ['\u{274E}', 'symbols:cross_square'],
    ['\u{2753}', 'symbols:question'],
    ['\u{2754}', 'symbols:question_white'],
    ['\u{2755}', 'symbols:exclamation_white'],
    ['\u{2757}', 'symbols:exclamation'],
    ['\u{2763}\u{FE0F}', 'symbols:heart_exclamation'],
    ['\u{2795}', 'symbols:plus'],
    ['\u{2B05}\u{FE0F}', 'symbols:arrow/left'],
    ['\u{2B06}\u{FE0F}', 'symbols:arrow/up'],
    ['\u{2B07}\u{FE0F}', 'symbols:arrow/down'],
    ['\u{27A1}\u{FE0F}', 'symbols:arrow/right'],
    ['\u{2B55}', 'symbols:circle_red'],
    ['\u{1F1E6}', 'symbols:letter/a'],
    ['\u{1F1E7}', 'symbols:letter/b'],
    ['\u{1F1E8}', 'symbols:letter/c'],
    ['\u{1F1E9}', 'symbols:letter/d'],
    ['\u{1F1EA}', 'symbols:letter/e'],
    ['\u{1F1EB}', 'symbols:letter/f'],
    ['\u{1F1EC}', 'symbols:letter/g'],
    ['\u{1F1ED}', 'symbols:letter/h'],
    ['\u{1F1EE}', 'symbols:letter/i'],
    ['\u{1F1EF}', 'symbols:letter/j'],
    ['\u{1F1F0}', 'symbols:letter/k'],
    ['\u{1F1F1}', 'symbols:letter/l'],
    ['\u{1F1F2}', 'symbols:letter/m'],
    ['\u{1F1F3}', 'symbols:letter/n'],
    ['\u{1F1F4}', 'symbols:letter/o'],
    ['\u{1F1F5}', 'symbols:letter/p'],
    ['\u{1F1F6}', 'symbols:letter/q'],
    ['\u{1F1F7}', 'symbols:letter/r'],
    ['\u{1F1F8}', 'symbols:letter/s'],
    ['\u{1F1F9}', 'symbols:letter/t'],
    ['\u{1F1FA}', 'symbols:letter/u'],
    ['\u{1F1FB}', 'symbols:letter/v'],
    ['\u{1F1FC}', 'symbols:letter/w'],
    ['\u{1F1FD}', 'symbols:letter/x'],
    ['\u{1F1FE}', 'symbols:letter/y'],
    ['\u{1F1FF}', 'symbols:letter/z'],
    ['\u{267F}', 'symbols:wheelchair_symbol'],
    ['\u{1F51E}', 'symbols:no_one_under_eighteen'],
    ['\u{2622}\u{FE0F}', 'symbols:radioactive'],
    ['\u{2623}\u{FE0F}', 'symbols:biohazard'],
    ['\u{2197}\u{FE0F}', 'symbols:arrow/up_right'],
    ['\u{2198}\u{FE0F}', 'symbols:arrow/down_right'],
    ['\u{2199}\u{FE0F}', 'symbols:arrow/down_left'],
    ['\u{2196}\u{FE0F}', 'symbols:arrow/up_left'],
    ['\u{2195}\u{FE0F}', 'symbols:arrow/up_down'],
    ['\u{2194}\u{FE0F}', 'symbols:arrow/left_right'],
    ['\u{21A9}\u{FE0F}', 'symbols:arrow/right_arrow_curving_left'],
    ['\u{21AA}\u{FE0F}', 'symbols:arrow/left_arrow_curving_right'],
    ['\u{2934}\u{FE0F}', 'symbols:arrow/right_arrow_curving_up'],
    ['\u{2935}\u{FE0F}', 'symbols:arrow/right_arrow_curving_down'],
    ['\u{269B}\u{FE0F}', 'symbols:religion/atom_symbol'],
    ['\u{1F549}\u{FE0F}', 'symbols:religion/om'],
    ['\u{2638}\u{FE0F}', 'symbols:religion/wheel_of_dharma'],
    ['\u{262F}\u{FE0F}', 'symbols:religion/yin_yang'],
    ['\u{2626}\u{FE0F}', 'symbols:religion/orthodox_cross'],
    ['\u{262A}\u{FE0F}', 'symbols:religion/star_and_crescent'],
    ['\u{262E}\u{FE0F}', 'symbols:religion/peace_symbol'],
    ['\u{1F54E}', 'symbols:religion/menorah'],
    ['\u{1F52F}', 'symbols:religion/dotted_six_pointed_star'],
    ['\u{2648}', 'symbols:zodiac/aries'],
    ['\u{2649}', 'symbols:zodiac/taurus'],
    ['\u{264A}', 'symbols:zodiac/gemini'],
    ['\u{264B}', 'symbols:zodiac/cancer'],
    ['\u{264C}', 'symbols:zodiac/leo'],
    ['\u{264D}', 'symbols:zodiac/virgo'],
    ['\u{264E}', 'symbols:zodiac/libra'],
    ['\u{264F}', 'symbols:zodiac/scorpio'],
    ['\u{2650}', 'symbols:zodiac/sagittarius'],
    ['\u{2651}', 'symbols:zodiac/capricorn'],
    ['\u{2652}', 'symbols:zodiac/aquarius'],
    ['\u{2653}', 'symbols:zodiac/pisces'],
    ['\u{25B6}\u{FE0F}', 'symbols:av/play'],
    ['\u{23E9}', 'symbols:av/fast_forward'],
    ['\u{23ED}\u{FE0F}', 'symbols:av/next_track'],
    ['\u{23EF}\u{FE0F}', 'symbols:av/play_or_pause'],
    ['\u{25C0}\u{FE0F}', 'symbols:av/reverse'],
    ['\u{23EA}', 'symbols:av/fast_reverse'],
    ['\u{23EE}\u{FE0F}', 'symbols:av/last_track'],
    ['\u{23EB}', 'symbols:av/fast_up'],
    ['\u{23EC}', 'symbols:av/fast_down'],
    ['\u{23F8}\u{FE0F}', 'symbols:av/pause'],
    ['\u{23F9}\u{FE0F}', 'symbols:av/stop'],
    ['\u{23FA}\u{FE0F}', 'symbols:av/record'],
    ['\u{23CF}\u{FE0F}', 'symbols:av/eject'],
    ['\u{1F6DC}', 'symbols:av/wireless'],
    ['\u{2640}\u{FE0F}', 'symbols:female_sign'],
    ['\u{2642}\u{FE0F}', 'symbols:male_sign'],
    ['\u{26A7}\u{FE0F}', 'symbols:transgender_symbol'],
    ['\u{1F7F0}', 'symbols:math/heavy_equals_sign'],
    ['\u{267E}\u{FE0F}', 'symbols:math/infinity'],
    ['\u{203C}\u{FE0F}', 'symbols:double_exclamation_mark'],
    ['\u{2049}\u{FE0F}', 'symbols:exclamation_question_mark'],
    ['\u{3030}\u{FE0F}', 'symbols:wavy_dash'],
    ['\u{2695}\u{FE0F}', 'symbols:medical_symbol'],
    ['\u{267B}\u{FE0F}', 'symbols:recycling_symbol'],
    ['\u{269C}\u{FE0F}', 'symbols:fleur_de_lis'],
    ['\u{2611}\u{FE0F}', 'symbols:check_box_with_check'],
    ['\u{303D}\u{FE0F}', 'symbols:part_alternation_mark'],
    ['\u{A9}\u{FE0F}', 'symbols:copyright'],
    ['\u{AE}\u{FE0F}', 'symbols:registered'],
    ['\u{2122}\u{FE0F}', 'symbols:trade_mark'],
    ['\u{1FADF}', 'symbols:splatter'],
    ['\u{23}\u{FE0F}\u{20E3}', 'symbols:keycap/hash'],
    ['\u{2A}\u{FE0F}\u{20E3}', 'symbols:keycap/asterisk'],
    ['\u{30}\u{FE0F}\u{20E3}', 'symbols:keycap/zero'],
    ['\u{31}\u{FE0F}\u{20E3}', 'symbols:keycap/one'],
    ['\u{32}\u{FE0F}\u{20E3}', 'symbols:keycap/two'],
    ['\u{33}\u{FE0F}\u{20E3}', 'symbols:keycap/three'],
    ['\u{34}\u{FE0F}\u{20E3}', 'symbols:keycap/four'],
    ['\u{35}\u{FE0F}\u{20E3}', 'symbols:keycap/five'],
    ['\u{36}\u{FE0F}\u{20E3}', 'symbols:keycap/six'],
    ['\u{37}\u{FE0F}\u{20E3}', 'symbols:keycap/seven'],
    ['\u{38}\u{FE0F}\u{20E3}', 'symbols:keycap/eight'],
    ['\u{39}\u{FE0F}\u{20E3}', 'symbols:keycap/nine'],
    ['\u{1F51F}', 'symbols:keycap/ten'],
    ['\u{1F520}', 'symbols:button/input_latin_uppercase'],
    ['\u{1F521}', 'symbols:button/input_latin_lowercase'],
    ['\u{1F522}', 'symbols:button/input_numbers'],
    ['\u{1F523}', 'symbols:button/input_symbols'],
    ['\u{1F524}', 'symbols:button/input_latin_letters'],
    ['\u{1F170}\u{FE0F}', 'symbols:button/a_blood_type'],
    ['\u{1F18E}', 'symbols:button/ab_blood_type'],
    ['\u{1F171}\u{FE0F}', 'symbols:button/b_blood_type'],
    ['\u{1F191}', 'symbols:button/cl'],
    ['\u{1F192}', 'symbols:button/cool'],
    ['\u{1F193}', 'symbols:button/free'],
    ['\u{2139}\u{FE0F}', 'symbols:button/information'],
    ['\u{1F194}', 'symbols:button/id'],
    ['\u{24C2}\u{FE0F}', 'symbols:button/circled_m'],
    ['\u{1F195}', 'symbols:button/new'],
    ['\u{1F196}', 'symbols:button/ng'],
    ['\u{1F17E}\u{FE0F}', 'symbols:button/o_blood_type'],
    ['\u{1F197}', 'symbols:button/ok'],
    ['\u{1F17F}\u{FE0F}', 'symbols:button/p'],
    ['\u{1F198}', 'symbols:button/sos'],
    ['\u{1F199}', 'symbols:button/up'],
    ['\u{1F19A}', 'symbols:button/vs'],
    ['\u{1F7E0}', 'symbols:shape/orange_circle'],
    ['\u{1F7E1}', 'symbols:shape/yellow_circle'],
    ['\u{1F7E2}', 'symbols:shape/green_circle'],
    ['\u{1F7E3}', 'symbols:shape/purple_circle'],
    ['\u{1F7E4}', 'symbols:shape/brown_circle'],
    ['\u{1F7E5}', 'symbols:shape/red_square'],
    ['\u{1F7E7}', 'symbols:shape/orange_square'],
    ['\u{1F7E8}', 'symbols:shape/yellow_square'],
    ['\u{1F7E9}', 'symbols:shape/green_square'],
    ['\u{1F7E6}', 'symbols:shape/blue_square'],
    ['\u{1F7EA}', 'symbols:shape/purple_square'],
    ['\u{1F7EB}', 'symbols:shape/brown_square'],
    ['\u{25FC}\u{FE0F}', 'symbols:shape/black_medium_square'],
    ['\u{25FB}\u{FE0F}', 'symbols:shape/white_medium_square'],
    ['\u{25FE}', 'symbols:shape/black_medium_small_square'],
    ['\u{25FD}', 'symbols:shape/white_medium_small_square'],
    ['\u{25AA}\u{FE0F}', 'symbols:shape/black_small_square'],
    ['\u{25AB}\u{FE0F}', 'symbols:shape/white_small_square'],
    ['\u{1F4A0}', 'symbols:shape/diamond_with_a_dot'],
    ['\u{1F3F3}\u{FE0F}', 'flags:white'],
    ['\u{1F1E6}\u{1F1E8}', 'flags:country/ac'],
    ['\u{1F1E6}\u{1F1E9}', 'flags:country/ad'],
    ['\u{1F1E6}\u{1F1EA}', 'flags:country/ae'],
    ['\u{1F1E6}\u{1F1EB}', 'flags:country/af'],
    ['\u{1F1E6}\u{1F1EC}', 'flags:country/ag'],
    ['\u{1F1E6}\u{1F1EE}', 'flags:country/ai'],
    ['\u{1F1E6}\u{1F1F1}', 'flags:country/al'],
    ['\u{1F1E6}\u{1F1F2}', 'flags:country/am'],
    ['\u{1F1E6}\u{1F1F4}', 'flags:country/ao'],
    ['\u{1F1E6}\u{1F1F6}', 'flags:country/aq'],
    ['\u{1F1E6}\u{1F1F7}', 'flags:country/ar'],
    ['\u{1F1E6}\u{1F1F8}', 'flags:country/as'],
    ['\u{1F1E6}\u{1F1F9}', 'flags:country/at'],
    ['\u{1F1E6}\u{1F1FA}', 'flags:country/au'],
    ['\u{1F1E6}\u{1F1FC}', 'flags:country/aw'],
    ['\u{1F1E6}\u{1F1FD}', 'flags:country/ax'],
    ['\u{1F1E6}\u{1F1FE}', 'flags:country/az'],
    ['\u{1F1E6}\u{1F1FF}', 'flags:country/az'],
    ['\u{1F1E7}\u{1F1E6}', 'flags:country/ba'],
    ['\u{1F1E7}\u{1F1E7}', 'flags:country/bb'],
    ['\u{1F1E7}\u{1F1E9}', 'flags:country/bd'],
    ['\u{1F1E7}\u{1F1EA}', 'flags:country/be'],
    ['\u{1F1E7}\u{1F1EB}', 'flags:country/bf'],
    ['\u{1F1E7}\u{1F1EC}', 'flags:country/bg'],
    ['\u{1F1E7}\u{1F1ED}', 'flags:country/bh'],
    ['\u{1F1E7}\u{1F1EE}', 'flags:country/bi'],
    ['\u{1F1E7}\u{1F1EF}', 'flags:country/bj'],
    ['\u{1F1E7}\u{1F1F1}', 'flags:country/bl'],
    ['\u{1F1E7}\u{1F1F2}', 'flags:country/bm'],
    ['\u{1F1E7}\u{1F1F3}', 'flags:country/bn'],
    ['\u{1F1E7}\u{1F1F4}', 'flags:country/bo'],
    ['\u{1F1E7}\u{1F1F6}', 'flags:country/bq'],
    ['\u{1F1E7}\u{1F1F7}', 'flags:country/br'],
    ['\u{1F1E7}\u{1F1F8}', 'flags:country/bs'],
    ['\u{1F1E7}\u{1F1F9}', 'flags:country/bt'],
    ['\u{1F1E7}\u{1F1FB}', 'flags:country/bv'],
    ['\u{1F1E7}\u{1F1FC}', 'flags:country/bw'],
    ['\u{1F1E7}\u{1F1FE}', 'flags:country/by'],
    ['\u{1F1E7}\u{1F1FF}', 'flags:country/bz'],
    ['\u{1F1E8}\u{1F1E6}', 'flags:country/ca'],
    ['\u{1F1E8}\u{1F1E8}', 'flags:country/cc'],
    ['\u{1F1E8}\u{1F1E9}', 'flags:country/cd'],
    ['\u{1F1E8}\u{1F1EB}', 'flags:country/cf'],
    ['\u{1F1E8}\u{1F1EC}', 'flags:country/cg'],
    ['\u{1F1E8}\u{1F1ED}', 'flags:country/ch'],
    ['\u{1F1E8}\u{1F1EE}', 'flags:country/ci'],
    ['\u{1F1E8}\u{1F1F0}', 'flags:country/ck'],
    ['\u{1F1E8}\u{1F1F1}', 'flags:country/cl'],
    ['\u{1F1E8}\u{1F1F2}', 'flags:country/cm'],
    ['\u{1F1E8}\u{1F1F3}', 'flags:country/cn'],
    ['\u{1F1E8}\u{1F1F4}', 'flags:country/co'],
    ['\u{1F1E8}\u{1F1F5}', 'flags:country/cp'],
    ['\u{1F1E8}\u{1F1F7}', 'flags:country/cr'],
    ['\u{1F1E8}\u{1F1FA}', 'flags:country/cu'],
    ['\u{1F1E8}\u{1F1FB}', 'flags:country/cv'],
    ['\u{1F1E8}\u{1F1FC}', 'flags:country/cw'],
    ['\u{1F1E8}\u{1F1FD}', 'flags:country/cx'],
    ['\u{1F1E8}\u{1F1FE}', 'flags:country/cy'],
    ['\u{1F1E8}\u{1F1FF}', 'flags:country/cz'],
    ['\u{1F1E9}\u{1F1EA}', 'flags:country/de'],
    ['\u{1F1E9}\u{1F1EC}', 'flags:country/dg'],
    ['\u{1F1E9}\u{1F1EF}', 'flags:country/dj'],
    ['\u{1F1E9}\u{1F1F0}', 'flags:country/dk'],
    ['\u{1F1E9}\u{1F1F2}', 'flags:country/dm'],
    ['\u{1F1E9}\u{1F1F4}', 'flags:country/do'],
    ['\u{1F1E9}\u{1F1FF}', 'flags:country/dz'],
    ['\u{1F1EA}\u{1F1E6}', 'flags:country/ea'],
    ['\u{1F1EA}\u{1F1E8}', 'flags:country/ec'],
    ['\u{1F1EA}\u{1F1EA}', 'flags:country/ee'],
    ['\u{1F1EA}\u{1F1EC}', 'flags:country/eg'],
    ['\u{1F1EA}\u{1F1ED}', 'flags:country/eh'],
    ['\u{1F1EA}\u{1F1F7}', 'flags:country/er'],
    ['\u{1F1EA}\u{1F1F8}', 'flags:country/es'],
    ['\u{1F1EA}\u{1F1F9}', 'flags:country/et'],
    ['\u{1F1EA}\u{1F1FA}', 'flags:country/eu'],
    ['\u{1F1EB}\u{1F1EE}', 'flags:country/fi'],
    ['\u{1F1EB}\u{1F1EF}', 'flags:country/fj'],
    ['\u{1F1EB}\u{1F1F0}', 'flags:country/fk'],
    ['\u{1F1EB}\u{1F1F2}', 'flags:country/fm'],
    ['\u{1F1EB}\u{1F1F4}', 'flags:country/fo'],
    ['\u{1F1EB}\u{1F1F7}', 'flags:country/fr'],
    ['\u{1F1EC}\u{1F1E6}', 'flags:country/ga'],
    ['\u{1F1EC}\u{1F1E7}', 'flags:country/gb'],
    ['\u{1F1EC}\u{1F1E9}', 'flags:country/gd'],
    ['\u{1F1EC}\u{1F1EA}', 'flags:country/ge'],
    ['\u{1F1EC}\u{1F1EB}', 'flags:country/gf'],
    ['\u{1F1EC}\u{1F1EC}', 'flags:country/gg'],
    ['\u{1F1EC}\u{1F1ED}', 'flags:country/gh'],
    ['\u{1F1EC}\u{1F1EE}', 'flags:country/gi'],
    ['\u{1F1EC}\u{1F1F1}', 'flags:country/gl'],
    ['\u{1F1EC}\u{1F1F2}', 'flags:country/gm'],
    ['\u{1F1EC}\u{1F1F3}', 'flags:country/gn'],
    ['\u{1F1EC}\u{1F1F5}', 'flags:country/gp'],
    ['\u{1F1EC}\u{1F1F6}', 'flags:country/gq'],
    ['\u{1F1EC}\u{1F1F7}', 'flags:country/gr'],
    ['\u{1F1EC}\u{1F1F8}', 'flags:country/gs'],
    ['\u{1F1EC}\u{1F1F9}', 'flags:country/gt'],
    ['\u{1F1EC}\u{1F1FA}', 'flags:country/gu'],
    ['\u{1F1EC}\u{1F1FC}', 'flags:country/gw'],
    ['\u{1F1EC}\u{1F1FE}', 'flags:country/gy'],
    ['\u{1F1ED}\u{1F1F0}', 'flags:country/hk'],
    ['\u{1F1ED}\u{1F1F2}', 'flags:country/hm'],
    ['\u{1F1ED}\u{1F1F3}', 'flags:country/hn'],
    ['\u{1F1ED}\u{1F1F7}', 'flags:country/hr'],
    ['\u{1F1ED}\u{1F1F9}', 'flags:country/ht'],
    ['\u{1F1ED}\u{1F1FA}', 'flags:country/hu'],
    ['\u{1F1EE}\u{1F1E8}', 'flags:country/ic'],
    ['\u{1F1EE}\u{1F1E9}', 'flags:country/id'],
    ['\u{1F1EE}\u{1F1EA}', 'flags:country/ie'],
    ['\u{1F1EE}\u{1F1F1}', 'flags:country/il'],
    ['\u{1F1EE}\u{1F1F2}', 'flags:country/im'],
    ['\u{1F1EE}\u{1F1F3}', 'flags:country/in'],
    ['\u{1F1EE}\u{1F1F4}', 'flags:country/io'],
    ['\u{1F1EE}\u{1F1F6}', 'flags:country/iq'],
    ['\u{1F1EE}\u{1F1F7}', 'flags:country/ir'],
    ['\u{1F1EE}\u{1F1F8}', 'flags:country/is'],
    ['\u{1F1EE}\u{1F1F9}', 'flags:country/it'],
    ['\u{1F1EF}\u{1F1EA}', 'flags:country/je'],
    ['\u{1F1EF}\u{1F1F2}', 'flags:country/jm'],
    ['\u{1F1EF}\u{1F1F4}', 'flags:country/jo'],
    ['\u{1F1EF}\u{1F1F5}', 'flags:country/jp'],
    ['\u{1F1F0}\u{1F1EA}', 'flags:country/ke'],
    ['\u{1F1F0}\u{1F1EC}', 'flags:country/kg'],
    ['\u{1F1F0}\u{1F1ED}', 'flags:country/kh'],
    ['\u{1F1F0}\u{1F1EE}', 'flags:country/ki'],
    ['\u{1F1F0}\u{1F1F2}', 'flags:country/km'],
    ['\u{1F1F0}\u{1F1F3}', 'flags:country/kn'],
    ['\u{1F1F0}\u{1F1F5}', 'flags:country/kp'],
    ['\u{1F1F0}\u{1F1F7}', 'flags:country/kr'],
    ['\u{1F1F0}\u{1F1FC}', 'flags:country/kw'],
    ['\u{1F1F0}\u{1F1FE}', 'flags:country/ky'],
    ['\u{1F1F0}\u{1F1FF}', 'flags:country/kz'],
    ['\u{1F1F1}\u{1F1E6}', 'flags:country/la'],
    ['\u{1F1F1}\u{1F1E7}', 'flags:country/lb'],
    ['\u{1F1F1}\u{1F1E8}', 'flags:country/lc'],
    ['\u{1F1F1}\u{1F1EE}', 'flags:country/li'],
    ['\u{1F1F1}\u{1F1F0}', 'flags:country/lk'],
    ['\u{1F1F1}\u{1F1F7}', 'flags:country/lr'],
    ['\u{1F1F1}\u{1F1F8}', 'flags:country/ls'],
    ['\u{1F1F1}\u{1F1F9}', 'flags:country/lt'],
    ['\u{1F1F1}\u{1F1FA}', 'flags:country/lu'],
    ['\u{1F1F1}\u{1F1FB}', 'flags:country/lv'],
    ['\u{1F1F1}\u{1F1FE}', 'flags:country/ly'],
    ['\u{1F1F2}\u{1F1E6}', 'flags:country/ma'],
    ['\u{1F1F2}\u{1F1E8}', 'flags:country/mc'],
    ['\u{1F1F2}\u{1F1E9}', 'flags:country/md'],
    ['\u{1F1F2}\u{1F1EA}', 'flags:country/me'],
    ['\u{1F1F2}\u{1F1EB}', 'flags:country/mf'],
    ['\u{1F1F2}\u{1F1EC}', 'flags:country/mg'],
    ['\u{1F1F2}\u{1F1ED}', 'flags:country/mh'],
    ['\u{1F1F2}\u{1F1F0}', 'flags:country/mk'],
    ['\u{1F1F2}\u{1F1F1}', 'flags:country/ml'],
    ['\u{1F1F2}\u{1F1F2}', 'flags:country/mm'],
    ['\u{1F1F2}\u{1F1F3}', 'flags:country/mn'],
    ['\u{1F1F2}\u{1F1F4}', 'flags:country/mo'],
    ['\u{1F1F2}\u{1F1F5}', 'flags:country/mp'],
    ['\u{1F1F2}\u{1F1F6}', 'flags:country/mq'],
    ['\u{1F1F2}\u{1F1F7}', 'flags:country/mr'],
    ['\u{1F1F2}\u{1F1F8}', 'flags:country/ms'],
    ['\u{1F1F2}\u{1F1F9}', 'flags:country/mt'],
    ['\u{1F1F2}\u{1F1FA}', 'flags:country/mu'],
    ['\u{1F1F2}\u{1F1FB}', 'flags:country/mv'],
    ['\u{1F1F2}\u{1F1FC}', 'flags:country/mw'],
    ['\u{1F1F2}\u{1F1FD}', 'flags:country/mx'],
    ['\u{1F1F2}\u{1F1FE}', 'flags:country/my'],
    ['\u{1F1F2}\u{1F1FF}', 'flags:country/mz'],
    ['\u{1F1F3}\u{1F1E6}', 'flags:country/na'],
    ['\u{1F1F3}\u{1F1E8}', 'flags:country/nc'],
    ['\u{1F1F3}\u{1F1EA}', 'flags:country/ne'],
    ['\u{1F1F3}\u{1F1EB}', 'flags:country/nf'],
    ['\u{1F1F3}\u{1F1EC}', 'flags:country/ng'],
    ['\u{1F1F3}\u{1F1EE}', 'flags:country/ni'],
    ['\u{1F1F3}\u{1F1F1}', 'flags:country/nl'],
    ['\u{1F1F3}\u{1F1F4}', 'flags:country/no'],
    ['\u{1F1F3}\u{1F1F5}', 'flags:country/np'],
    ['\u{1F1F3}\u{1F1F7}', 'flags:country/nr'],
    ['\u{1F1F3}\u{1F1FA}', 'flags:country/nu'],
    ['\u{1F1F3}\u{1F1FF}', 'flags:country/nz'],
    ['\u{1F1F4}\u{1F1F2}', 'flags:country/om'],
    ['\u{1F1F5}\u{1F1E6}', 'flags:country/pa'],
    ['\u{1F1F5}\u{1F1EA}', 'flags:country/pe'],
    ['\u{1F1F5}\u{1F1EB}', 'flags:country/pf'],
    ['\u{1F1F5}\u{1F1EC}', 'flags:country/pg'],
    ['\u{1F1F5}\u{1F1ED}', 'flags:country/ph'],
    ['\u{1F1F5}\u{1F1F0}', 'flags:country/pk'],
    ['\u{1F1F5}\u{1F1F1}', 'flags:country/pl'],
    ['\u{1F1F5}\u{1F1F2}', 'flags:country/pm'],
    ['\u{1F1F5}\u{1F1F3}', 'flags:country/pn'],
    ['\u{1F1F5}\u{1F1F7}', 'flags:country/pr'],
    ['\u{1F1F5}\u{1F1F8}', 'flags:country/ps'],
    ['\u{1F1F5}\u{1F1F9}', 'flags:country/pt'],
    ['\u{1F1F5}\u{1F1FC}', 'flags:country/pw'],
    ['\u{1F1F5}\u{1F1FE}', 'flags:country/py'],
    ['\u{1F1F6}\u{1F1E6}', 'flags:country/qa'],
    ['\u{1F1F7}\u{1F1EA}', 'flags:country/re'],
    ['\u{1F1F7}\u{1F1F4}', 'flags:country/ro'],
    ['\u{1F1F7}\u{1F1F8}', 'flags:country/rs'],
    ['\u{1F1F7}\u{1F1FA}', 'flags:country/ru'],
    ['\u{1F1F7}\u{1F1FC}', 'flags:country/rw'],
    ['\u{1F1F8}\u{1F1E6}', 'flags:country/sa'],
    ['\u{1F1F8}\u{1F1E7}', 'flags:country/sb'],
    ['\u{1F1F8}\u{1F1E8}', 'flags:country/sc'],
    ['\u{1F1F8}\u{1F1E9}', 'flags:country/sd'],
    ['\u{1F1F8}\u{1F1EA}', 'flags:country/se'],
    ['\u{1F1F8}\u{1F1EC}', 'flags:country/sg'],
    ['\u{1F1F8}\u{1F1ED}', 'flags:country/sh'],
    ['\u{1F1F8}\u{1F1EE}', 'flags:country/si'],
    ['\u{1F1F8}\u{1F1EF}', 'flags:country/sj'],
    ['\u{1F1F8}\u{1F1F0}', 'flags:country/sk'],
    ['\u{1F1F8}\u{1F1F1}', 'flags:country/sl'],
    ['\u{1F1F8}\u{1F1F2}', 'flags:country/sm'],
    ['\u{1F1F8}\u{1F1F3}', 'flags:country/sn'],
    ['\u{1F1F8}\u{1F1F4}', 'flags:country/so'],
    ['\u{1F1F8}\u{1F1F7}', 'flags:country/sr'],
    ['\u{1F1F8}\u{1F1F8}', 'flags:country/ss'],
    ['\u{1F1F8}\u{1F1F9}', 'flags:country/st'],
    ['\u{1F1F8}\u{1F1FB}', 'flags:country/sv'],
    ['\u{1F1F8}\u{1F1FD}', 'flags:country/sx'],
    ['\u{1F1F8}\u{1F1FE}', 'flags:country/sy'],
    ['\u{1F1F8}\u{1F1FF}', 'flags:country/sz'],
    ['\u{1F1F9}\u{1F1E6}', 'flags:country/ta'],
    ['\u{1F1F9}\u{1F1E8}', 'flags:country/tc'],
    ['\u{1F1F9}\u{1F1E9}', 'flags:country/td'],
    ['\u{1F1F9}\u{1F1EB}', 'flags:country/tf'],
    ['\u{1F1F9}\u{1F1EC}', 'flags:country/tg'],
    ['\u{1F1F9}\u{1F1ED}', 'flags:country/th'],
    ['\u{1F1F9}\u{1F1EF}', 'flags:country/tj'],
    ['\u{1F1F9}\u{1F1F0}', 'flags:country/tk'],
    ['\u{1F1F9}\u{1F1F1}', 'flags:country/tl'],
    ['\u{1F1F9}\u{1F1F2}', 'flags:country/tm'],
    ['\u{1F1F9}\u{1F1F3}', 'flags:country/tn'],
    ['\u{1F1F9}\u{1F1F4}', 'flags:country/to'],
    ['\u{1F1F9}\u{1F1F7}', 'flags:country/tr'],
    ['\u{1F1F9}\u{1F1F9}', 'flags:country/tt'],
    ['\u{1F1F9}\u{1F1FB}', 'flags:country/tv'],
    ['\u{1F1F9}\u{1F1FC}', 'flags:country/tw'],
    ['\u{1F1F9}\u{1F1FE}', 'flags:country/tz'],
    ['\u{1F1F9}\u{1F1FF}', 'flags:country/tz'],
    ['\u{1F1FA}\u{1F1E6}', 'flags:country/ua'],
    ['\u{1F1FA}\u{1F1EC}', 'flags:country/ug'],
    ['\u{1F1FA}\u{1F1F2}', 'flags:country/um'],
    ['\u{1F1FA}\u{1F1F3}', 'flags:country/un'],
    ['\u{1F1FA}\u{1F1F8}', 'flags:country/us'],
    ['\u{1F1FA}\u{1F1FE}', 'flags:country/uy'],
    ['\u{1F1FA}\u{1F1FF}', 'flags:country/uz'],
    ['\u{1F1FB}\u{1F1E6}', 'flags:country/va'],
    ['\u{1F1FB}\u{1F1E8}', 'flags:country/vc'],
    ['\u{1F1FB}\u{1F1EA}', 'flags:country/ve'],
    ['\u{1F1FB}\u{1F1EC}', 'flags:country/vg'],
    ['\u{1F1FB}\u{1F1EE}', 'flags:country/vi'],
    ['\u{1F1FB}\u{1F1F3}', 'flags:country/vn'],
    ['\u{1F1FB}\u{1F1FA}', 'flags:country/vu'],
    ['\u{1F1FC}\u{1F1EB}', 'flags:country/wf'],
    ['\u{1F1FC}\u{1F1F8}', 'flags:country/ws'],
    ['\u{1F1FD}\u{1F1F0}', 'flags:country/xk'],
    ['\u{1F1FE}\u{1F1EA}', 'flags:country/ye'],
    ['\u{1F1FE}\u{1F1F9}', 'flags:country/yt'],
    ['\u{1F1FF}\u{1F1E6}', 'flags:country/za'],
    ['\u{1F1FF}\u{1F1F2}', 'flags:country/zm'],
    ['\u{1F1FF}\u{1F1FC}', 'flags:country/zw'],
    ['\u{1F3F4}\u{E0067}\u{E0062}\u{E006E}\u{E0067}\u{E007F}', 'flags:subdivision/gb_eng'],
    ['\u{1F3F4}\u{E0067}\u{E0062}\u{E0073}\u{E0063}\u{E0074}\u{E007F}', 'flags:subdivision/gb_sct'],
    ['\u{1F3F4}\u{E0067}\u{E0062}\u{E0077}\u{E006C}\u{E0073}\u{E007F}', 'flags:subdivision/gb_wls'],
    ['\u{1F3F3}\u{FE0F}\u{200D}\u{1F308}', 'flags:pride/rainbow'],
    ['\u{1F3F3}\u{FE0F}\u{200D}\u{26A7}\u{FE0F}', 'flags:pride/trans'],
    ['\u{1F3F3}\u{FE0F}\u{200D}\u{26B2}\u{FE0F}', 'flags:pride/asexual'],
    ['\u{1F3F4}\u{200D}\u{2620}\u{FE0F}', 'flags:pirate_flag'],
    ['\u{1F1E8}\u{1F1F6}', 'flags:country/cq'],
    ['\u{1F3F4}\u{E0067}\u{E0062}\u{E0065}\u{E006E}\u{E0067}\u{E007F}', 'flags:subdivision/england'],
    ['\u{1F5E3}\u{FE0F}', 'smileys:speaking_head'],
    ['\u{1F5FB}', 'travel:japan/fuji'],
    ['\u{1FA9E}', 'objects:mirror'],
    ['\u{26F4}', 'travel:ferry'],
])

export function polymoji_get_unicode_lookup_table(): Map<string, string>
{
    return LookupTable;
}

export function polymoji_get_unicode_points(emoji: string): string[]
{
    return Array.from([...LookupTable.entries()].find(([, value]) => value === emoji)?.[0] ?? '\u{fffd}').map(char => char.codePointAt(0)!.toString(16).toLowerCase());
}